import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import lodashGet from 'lodash/get';
import { mailBoxOfDefault, mailBoxOfDefer, mailBoxOfRdFlag, mailBoxOfUnread, mailBoxOfSent, mailBoxOfWaitingIssue, methodMap, watchConf, mailBoxOfUnFollow, mailBoxOfCustomerUnFollow, mailUnfinishedMailTable, } from './mail_action_store_model';
import { api } from '@/api/api';
import { FLOLDER, NoSetDeferTime, } from '@/api/logical/mail';
import { FileSourceType } from '@/api/system/fileLoader';
import { MailAbstractHandler } from './mail_abs_handler';
import { ErrResult } from '@/api/errMap';
import { apis, inWindow, getUrl } from '@/config';
import { MailFolderHandler } from './mail_folder_handler';
import { getXmlByObject, getFolderStartContactId, pathNotInArrJudge, util, wait, getIsEncryptedMail, isOwnDomainEmail } from '@/api/util';
import corpMailUtils from './corp_mail_utils';
import { locationHelper } from '@/api/util/location_helper';
import { getIn18Text, setMailListAttSource, setMailAttSource } from '@/api/utils';
function mergeMailStatusList(statusList = [], externalStatusList = [], ownDomainSet) {
    return statusList.map(status => {
        const target = externalStatusList.find(newStatus => newStatus.to === status.to);
        if (!target) {
            return status;
        }
        status.inner = target.inner;
        if (status.inner === false && ownDomainSet && ownDomainSet.size > 0 && isOwnDomainEmail(target.to, ownDomainSet)) {
            status.inner = true;
            console.info('[read-status] alias-domain inner override', { to: target.to });
        }
        if (status.result >= 700) {
            return status;
        }
        if (target === null || target === void 0 ? void 0 : target.read) {
            status.result = 109;
            status.originModtime = status.modtime;
            status.modtime = util.formatDate(target.readTime);
            return status;
        }
        return status;
    });
}
export class MailContentHandler extends MailFolderHandler {
    constructor(actions, modelHandler, contactHandler, mailDbHandler, subActions) {
        super(actions, modelHandler, contactHandler, mailDbHandler, subActions);
        this.mailDbHandler = mailDbHandler;
        this.fileApi = api.getFileApi();
        this.errReportApi = api.requireLogicalApi(apis.errorReportImpl);
    }
    handleCacheStatus(res) {
        const tag = res.config.tag;
        if (tag && watchConf[tag]) {
            const item = watchConf[tag];
            if (item && item.updateStatus) {
                this.cleanCacheStatus();
                this.doUpdateMailBoxStat('default').then().catch(console.error);
            }
            if (item && item.cache) {
                const methodStatus = this.actions.methodStatus[tag];
                if (methodStatus && !methodStatus.refreshedKeys) {
                    methodStatus.refreshedKeys = new Set();
                }
                const value = res.config.rqKey || '';
                if (methodStatus && methodStatus.refreshedKeys && !methodStatus.refreshedKeys.has(value)) {
                    methodStatus.refreshedKeys.add(value);
                }
            }
        }
    }
    unpackData(res) {
        const isCorpMailMode = this.systemApi.getIsCorpMailMode();
        if (isCorpMailMode) {
            corpMailUtils.corpMailTransformResponse(res);
        }
        const data = res.data;
        if (res.uri.includes(getUrl('sendVariableMail')) && res.data) {
            res.data.code = res.data.data.code;
            return res.data;
        }
        if (data && data.code === (MailAbstractHandler.sOk || MailAbstractHandler.SuccessCode)) {
        }
        else {
            res.config.requestFailed = true;
        }
        return data;
    }
    unpackSubData(res) {
        var _a, _b;
        const isCorpMailMode = this.systemApi.getIsCorpMailMode();
        if (isCorpMailMode) {
            corpMailUtils.corpMailTransformResponse(res);
        }
        const data = res.data;
        if (data && data.code === 0) {
            if (((_a = data.data) === null || _a === void 0 ? void 0 : _a.attachments) && ((_b = data.data) === null || _b === void 0 ? void 0 : _b.attachments.length)) {
                data.data.attachments = data.data.attachments.map((item) => {
                    item.name = item.filename;
                    item.size = item.estimateSize;
                    item.id = isNaN(+item.id) ? item.id : +item.id;
                    return item;
                });
            }
            data.var = data.data;
            data.code = MailAbstractHandler.sOk;
        }
        else {
            res.config.requestFailed = true;
        }
        return data;
    }
    cleanCacheStatus(_account) {
        var _a;
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        console.log('clear cache called', targetActions.methodStatus);
    }
    async getStarMailBoxIdByEmail(model) {
        var _a, _b, _c, _d, _e, _f;
        const emailSet = new Set();
        const mailBoxIdSet = new Set();
        if ((_c = (_b = (_a = model.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.accountName) {
            emailSet.add((_f = (_e = (_d = model.sender) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.accountName);
        }
        if (Array.isArray(model.receiver) && model.receiver.length > 0) {
            model.receiver.forEach(v => {
                var _a, _b;
                const email = (_b = (_a = v === null || v === void 0 ? void 0 : v.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName;
                if (email) {
                    emailSet.add(email);
                }
            });
        }
        if (emailSet.size > 0) {
            const emails = [...emailSet];
            const starMap = await this.contactApi.doGetPersonalMarklistByEmail({ emails });
            if (starMap.size > 0) {
                starMap.forEach(v => {
                    v.forEach(it => {
                        const mailBoxId = getFolderStartContactId(it.id, it.type);
                        mailBoxIdSet.add(mailBoxId);
                    });
                });
            }
        }
        return [...mailBoxIdSet];
    }
    async doUpdateMailBoxStat(taskType, extraData, _account) {
        var _a, _b, _c;
        console.log('[mail sync] doUpdateMailBoxStat: ', taskType);
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const fids = targetActions.mailBoxDic ? this.getAllFids(undefined, _account) : [mailBoxOfDefault.id];
        const isThread = this.mailConfApi.getMailMergeSettings(_account) === 'true';
        let unread = 0;
        const accountMd5 = this.systemApi.md5(((_b = this.systemApi.getCurrentUser(_account)) === null || _b === void 0 ? void 0 : _b.id) || '----');
        if (taskType === 'push' && extraData && extraData.mid && extraData.accountId === accountMd5) {
            console.log('[mail-push] got ', extraData);
            const retrySend = async (retry, mid) => {
                if (retry > 0) {
                    try {
                        await wait(1000);
                        const model = await this.mailApi.doGetMailContent(mid, undefined, undefined, taskType, { _account });
                        if (model) {
                            console.log('[mail-push] got mail model ', model);
                            if (inWindow() && window.isAccountBg) {
                                this.mailApi.doListMailBox(true, false, undefined, _account).then();
                            }
                            else {
                                const starMailBoxIds = await this.getStarMailBoxIdByEmail(model);
                                await this.sendRefreshEvent(taskType, false, new Set([model.entry.folder, ...starMailBoxIds]), mid, _account);
                                if (this.systemApi.inEdm()) {
                                    this.mailApi.doUpdateCustomersByNewMail([model]).catch(e => {
                                        console.error('[edm mail] push customer', e);
                                    });
                                }
                            }
                            return true;
                        }
                        console.warn('[mail] got empty data when refresh push email ' + mid + ' ' + retry);
                        this.loggerApi.track('push_email_retrieve_failed', { retry, mid, msg: 'empty data' });
                        await wait((3 - retry) * 500);
                        return retrySend(retry - 1, mid);
                    }
                    catch (ex) {
                        console.warn('[mail] got error when refresh push email ' + mid + ' ' + retry, ex);
                        this.loggerApi.track('push_email_retrieve_failed', { retry, mid, msg: ex === null || ex === void 0 ? void 0 : ex.msg });
                        await wait((3 - retry) * 500);
                        return retrySend(retry - 1, mid);
                    }
                }
                else {
                    console.log('[mail-push] not got mail content for ' + mid);
                }
                return false;
            };
            const pushed = await retrySend(3, extraData.mid);
            if (pushed) {
                console.log('[mail-push]', pushed);
                return Promise.resolve();
            }
        }
        if (pathNotInArrJudge(window.location, ['/', 'api_data_init'])) {
            return Promise.resolve();
        }
        const differFolder = new Set();
        const retryGet = async (retry) => {
            console.log('[mail sync] statUnreadCount start');
            const res = await this.statUnreadCount(fids, false, _account);
            unread = Object.keys(res).reduce((prev, it) => {
                if (targetActions.mailBoxDic) {
                    const fid = Number(it);
                    const mailBoxDicElement = targetActions.mailBoxDic[fid];
                    if (mailBoxDicElement) {
                        const pre = isThread ? mailBoxDicElement.threadMailBoxTotal : mailBoxDicElement.mailBoxTotal;
                        const preUnread = isThread ? mailBoxDicElement.threadMailBoxUnread : mailBoxDicElement.mailBoxUnread;
                        const mailboxHasUnread = mailBoxDicElement.mailBoxId === mailBoxOfDefault.id ||
                            mailBoxDicElement.mailBoxType === 'customer' ||
                            mailBoxDicElement.mailBoxId === mailBoxOfWaitingIssue.id;
                        const dicItem = res[it];
                        const countDiffer = mailboxHasUnread
                            ? pre !== (isThread ? dicItem.threadCount : dicItem.messageCount) || preUnread !== (isThread ? dicItem.unreadThreadCount : dicItem.unreadMessageCount)
                            : pre !== (isThread ? dicItem.threadCount : dicItem.messageCount);
                        if (countDiffer) {
                            differFolder.add(fid);
                        }
                        if (mailboxHasUnread) {
                            prev += isThread ? dicItem.unreadThreadCount : dicItem.unreadMessageCount;
                        }
                    }
                }
                return prev;
            }, 0);
            this.modelHandler.updateUnreadCount(unread, _account);
            console.log('[mail sync] statUnreadCount end', unread);
            if (differFolder.size === 0 && retry > 0 && taskType === 'push') {
                await wait(1500 + 1000 * (3 - retry));
                await retryGet(retry - 1);
            }
        };
        await retryGet(2);
        console.log('[mail sync] statUnreadCount differFolder', differFolder);
        if (differFolder.size > 0) {
            this.refreshMailContent(differFolder, taskType, (_c = this.systemApi.getCurrentUser(_account)) === null || _c === void 0 ? void 0 : _c.id).then();
        }
        else {
            this.mailApi.doListMailBox(true, false, undefined, _account).then();
        }
        if (process.env.BUILD_ISELECTRON) {
            setTimeout(() => {
                this.mailApi.syncAllMails(200, 0, _account).then();
            }, 1500);
        }
        return Promise.resolve();
    }
    async refreshMailContent(differFolder, taskType, _account) {
        console.log('[mail] push differ count folder:', differFolder);
        if (differFolder && differFolder.size > 0) {
            await this.sendRefreshEvent(taskType, true, differFolder, undefined, _account);
        }
    }
    async sendRefreshEvent(taskType, noCache, fids, mid, _account) {
        const maxLastTime = 0;
        this.eventApi.sendSysEvent({
            eventName: 'mailChanged',
            eventStrData: 'data',
            eventData: {
                noCache,
                fid: fids,
                taskType,
                mid,
            },
            _account,
        });
        this.eventApi.sendSysEvent({
            eventName: 'mailChanged',
            eventStrData: 'refreshFolder',
            eventData: {
                noCache,
                taskType,
            },
            _account,
        });
        return maxLastTime;
    }
    statUnreadCount(fids, needFillIds, _account) {
        var _a;
        if (needFillIds && !fids) {
            const targetActions = (_a = this.mailApi.getActions({
                actions: this.actions,
                subActions: this.subActions,
                _account,
            })) === null || _a === void 0 ? void 0 : _a.val;
            if (!targetActions.mailBoxDic) {
                fids = [mailBoxOfDefault.id];
            }
            else {
                fids = Object.keys(targetActions.mailBoxDic).map(it => parseInt(it, 10));
            }
        }
        const url = this.buildUrl('getFolderStat', undefined, undefined, _account);
        const defaultResult = {};
        return this.impl
            .post(url, { ids: fids, threads: true, messages: true }, { contentType: 'json', cachePolicy: 'noCache', _account })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === MailAbstractHandler.sOk) {
                return res.var || defaultResult;
            }
            return Promise.reject(new Error('统计接口报错'));
        })
            .catch(ex => {
            console.error('statUnreadCount error', ex);
            return defaultResult;
        });
    }
    getMailPartHtml(mid, part, _account) {
        const requestData = {
            mid,
            part,
            mode: 'inline',
        };
        const key = 'getMailPart';
        const url = this.buildUrl(key);
        const requestConfig = this.getConfigForHttp(key, {
            url,
            data: part,
            method: 'post',
            contentType: 'form',
            responseType: 'text',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'text/html',
            },
            _account,
        });
        const isCorpMail = this.systemApi.getIsCorpMailMode(_account);
        return (isCorpMail ? this.impl.get(url, requestData, requestConfig) : this.impl.post(url, requestData, requestConfig)).then((res) => {
            if (res.rawData) {
                return res.rawData;
            }
            return '';
        });
    }
    getMailHeaders(mid, _account) {
        const requestData = {
            mid,
            action: 'read_head',
            mode: 'text',
        };
        const key = 'getMailPart';
        const url = this.buildUrl(key);
        return this.impl.post(url, requestData, { _account }).then((res) => res === null || res === void 0 ? void 0 : res.data);
    }
    async doGetMailContentIM(emailMid, teamId) {
        if (!emailMid) {
            return Promise.reject(new Error('emailMid is null'));
        }
        const httpApi = api.getDataTransApi();
        const url = this.systemApi.getUrl('getDiscussMailDetail');
        const mailEntryModelPromise = await httpApi
            .get(url, { emailMid, teamId })
            .then(res => {
            if (res && res.data && res.data.success) {
                return res.data.data;
            }
            return Promise.reject(new Error('获取邮件详情失败'));
        })
            .then(res => {
            const { available } = res;
            if (!available) {
                return Promise.reject(new Error('availableFail'));
            }
            const data = res.email;
            const prItem = this.contactHandler.mapMailEntryToProcessingItem(data, emailMid);
            const promise = this.contactHandler.handleContactList([prItem]);
            return promise;
        })
            .then((res) => this.handleMailContentResponse(res, true))
            .then(res => setMailAttSource(res, 'content'));
        return mailEntryModelPromise;
    }
    getMailContentPartProcessPromise(id, data, _account) {
        var _a, _b;
        const dataContentNotEmpty = !!data.html && !!data.html.contentLength && data.html.contentLength > 0;
        const hasHtmlMailContent = dataContentNotEmpty && (!data.html.content || data.html.content.length === 0);
        if (hasHtmlMailContent && ((_a = data === null || data === void 0 ? void 0 : data.html) === null || _a === void 0 ? void 0 : _a.id)) {
            return this.getMailPartHtml(id, (_b = data === null || data === void 0 ? void 0 : data.html) === null || _b === void 0 ? void 0 : _b.id, _account);
        }
        return Promise.resolve(dataContentNotEmpty ? data.html.content : '');
    }
    async doGetDecryptedContent(id, encpwd, _account) {
        const urlKey = 'decryptedContent';
        const url = this.buildUrl(urlKey, { l: 'read', action: 'decrypt' }, undefined, _account);
        const dt = {
            id,
            password: encpwd + '',
            mode: 'html',
        };
        const result = await this.impl.post(url, dt, this.getConfigForHttp(urlKey, {
            contentType: 'json',
            responseType: 'text',
            expectedResponseType: 'json',
            url,
            data: dt,
            method: 'post',
            cachePolicy: 'refresh',
            _account,
        }));
        const res = this.unpackData(result);
        if (res && res.code === MailAbstractHandler.sOk && res.var) {
            const { html = {}, attachments, text = {} } = res.var;
            if ((text === null || text === void 0 ? void 0 : text.contentType) === 'text/plain') {
                return {
                    passed: true,
                    data: {
                        html: {
                            content: (text === null || text === void 0 ? void 0 : text.content) || '',
                            contentId: (text === null || text === void 0 ? void 0 : text.id) || '',
                            contentLength: (text === null || text === void 0 ? void 0 : text.contentLength) || 0,
                        },
                        attachments,
                    },
                };
            }
            const content = await this.getMailContentPartProcessPromise(id, res.var, _account);
            return {
                passed: true,
                data: {
                    html: {
                        content,
                        contentId: html.id || '',
                        contentLength: html.contentLength || 0,
                    },
                    attachments,
                },
            };
        }
        return {
            passed: false,
            code: res.code,
            errMsg: MailContentHandler.decryptedErrorCode[res.code],
        };
    }
    async doGetMailContent(ids, conf) {
        var _a;
        const { noFlagInfo, noCache, noContactRace = false, _account, encoding, mustExist, mustExistInfo } = conf || {};
        if (!ids) {
            return Promise.reject(new Error('请填入邮件id'));
        }
        const id = ids;
        if (MailAbstractHandler.tmpIdFormat.test(id)) {
            const newId = id.replace('-tmp', '');
            const targetActions = this.mailApi.getActions({ actions: this.actions, subActions: this.subActions, _account }).val;
            if (targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailEntryCache[newId]) {
                const element = await this.modelHandler.loadEntryFromStore(newId, _account);
                if (element) {
                    return Promise.resolve(this.makeModelSafe(element));
                }
            }
            else {
                return Promise.reject(new Error('邮件id不存在'));
            }
        }
        const urlKey = 'listContent';
        const url = this.buildUrl(urlKey, { l: 'read', uid: ((_a = MailAbstractHandler.user) === null || _a === void 0 ? void 0 : _a.id) || '', supportTNEF: 'true' }, undefined, _account);
        const dt = {
            id,
            level: 32,
            mode: 'html',
            returnHeaders: {
                'Resent-From': 'A',
                Sender: 'A',
            },
            encoding: !encoding || encoding === 'default' ? undefined : encoding,
            markRead: false,
        };
        const mailEntryModelPromise = this.impl
            .post(url, dt, Object.assign(Object.assign({}, (this.getConfigForHttp(urlKey, {
            contentType: 'json',
            responseType: 'text',
            expectedResponseType: 'json',
            url,
            data: dt,
            method: 'post',
            cachePolicy: noCache ? 'refresh' : undefined,
        }) || {})), { _account }))
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (mustExist) {
                return this.getMailContentProcessResponse(id, mustExistInfo, noContactRace, _account);
            }
            if (res && res.code === MailAbstractHandler.sOk && res.var) {
                return this.getMailContentProcessResponse(id, res.var, noContactRace, _account);
            }
            return Promise.reject(this.getErrMsg(res.code));
        })
            .then((res) => {
            if (mustExist) {
                res[0].nonfold = true;
            }
            return this.handleMailContentResponse(res, undefined, undefined, encoding, _account);
        })
            .then(res => setMailAttSource(res, 'content'));
        const modelPromise = this.getMailContentMakeModelPromise({
            id,
            noFlagInfo,
            noCache,
            _account,
        });
        return Promise.all([modelPromise, mailEntryModelPromise])
            .then(res => this.getMailContentAssemble(res))
            .catch(reason => {
            console.warn(reason);
            if (reason === 'FA_MAIL_NOT_FOUND' || (reason === null || reason === void 0 ? void 0 : reason.message) === 'FA_MAIL_NOT_FOUND') {
                this.loggerApi.track('dogetmailcontontent_fail', {
                    reason: reason || (reason === null || reason === void 0 ? void 0 : reason.message),
                    id,
                });
            }
            return Promise.reject(this.commonCatch(reason));
        });
    }
    async handleRawMailContent(id, rawContent) {
        const contentProcessResponse = await this.getMailContentProcessResponse(id, rawContent);
        const model = await this.handleMailContentResponse(contentProcessResponse);
        return model;
    }
    async handleMailContentResponseAddTid(res1, res2, param) {
        var _a;
        const tpRes = res2.map(v => (Object.assign(Object.assign({}, v), { isTpMail: !!param.colleagueAccId || param.mailFrom === 'relatedEmail' ? true : v.isTpMail, owner: param.owner, subEmail: param.subEmail || param.owner, colleagueAccId: param.colleagueAccId })));
        if (res1 && !!param.colleagueAccId) {
            res1.mailFrom = 'subordinate';
        }
        else if (param.mailFrom === 'customer' || param.mailFrom === 'relatedEmail') {
            res1.mailFrom = param.mailFrom;
        }
        if (param.mailFrom === 'relatedEmail') {
            tpRes[0].relatedEmailType = param.type;
            tpRes[0].relatedEmailRefId = param.refId;
            res1.tpMailInfo = Object.assign(Object.assign({}, res1.tpMailInfo), { type: param.type, refId: param.refId });
            res1.isTpMail = true;
        }
        if (param.mailFrom) {
            tpRes[0].mailFrom = param.mailFrom;
        }
        tpRes[0].tid = (_a = res1 === null || res1 === void 0 ? void 0 : res1.entry) === null || _a === void 0 ? void 0 : _a.tid;
        const res22 = await this.handleMailContentResponse(tpRes);
        return [res1, res22];
    }
    doGetTpMailContentOld(param, checkType = 'checkCustomerMail') {
        const url = this.systemApi.getUrl(process.env.BUILD_ISEDM ? 'readTpMessage' : 'readLxTpMessage');
        let type;
        if (param.type === 'CUSTOMER') {
            type = 'conversation';
        }
        else if (param.type === 'LEADS') {
            type = 'hint';
        }
        else {
            type = 'customer';
        }
        const req = {
            email: param.owner,
            mid: param.mid,
            subEmail: param.subEmail || param.owner,
            refId: param.refId,
            type,
            mainAccount: param.mainAccount,
        };
        const mailEntryModelPromise = this.impl
            .post(url, req, {
            url,
            method: 'post',
            contentType: 'json',
            responseType: 'text',
            expectedResponseType: 'json',
        })
            .then(res => {
            var _a;
            const { data, code } = res.data;
            if (+code === 0 && data) {
                return this.getMailContentProcessResponse(req.mid, data);
            }
            if (((_a = res.data) === null || _a === void 0 ? void 0 : _a.message) === 'FA_MAIL_NOT_FOUND') {
                return Promise.reject(new Error(getIn18Text('GAIYOUJIANYBSCWFCKXQ')));
            }
            return Promise.reject(this.getErrMsg(code));
        });
        const modelPromise = this.getMailContentMakeModelPromise({
            id: req.mid,
            checkType,
            tpMids: { mids: [req.mid], email: req.email, subEmail: req.subEmail || req.email, mainAccount: param.mainAccount, refId: req.refId, type: req.type },
        }).catch(() => {
            console.error('getMailContentMakeModelPromise');
            return Promise.resolve(this.buildEmptyMailEntryModel({ id: req.mid }, true));
        });
        return Promise.all([modelPromise, mailEntryModelPromise])
            .then(res => this.handleMailContentResponseAddTid(res[0], res[1], param))
            .then(res => this.getMailContentAssemble(res))
            .catch(reason => {
            console.warn(reason);
            return Promise.reject(this.commonCatch(reason));
        });
    }
    doGetTpMailContent(param, checkType = 'checkSubordinateMail') {
        if (!param.colleagueAccId) {
            return this.doGetTpMailContentOld(param, param.mailFrom === 'customer' || param.mailFrom === 'relatedEmail' ? 'checkCustomerMail' : checkType);
        }
        const url = this.systemApi.getUrl('readTpMessageNew');
        const req = {
            email: param.owner,
            mid: param.mid,
            subEmail: param.subEmail || param.owner,
            colleagueAccId: param.colleagueAccId,
        };
        const mailEntryModelPromise = this.impl
            .post(url, req, {
            url,
            method: 'post',
            contentType: 'json',
            responseType: 'text',
            expectedResponseType: 'json',
        })
            .then(res => {
            const { data, code } = res.data;
            if (+code === 0 && data) {
                return this.getMailContentProcessResponse(req.mid, data);
            }
            return Promise.reject(this.getErrMsg(code));
        });
        const modelPromise = this.getMailContentMakeModelPromise({
            id: req.mid,
            checkType,
            tpMids: { mids: [req.mid], email: req.email, subEmail: req.subEmail || req.email, colleagueAccId: req.colleagueAccId },
        }).catch(() => {
            console.error('getMailContentMakeModelPromise');
            return Promise.resolve(this.buildEmptyMailEntryModel({ id: req.mid }, true));
        });
        return Promise.all([modelPromise, mailEntryModelPromise])
            .then(res => this.handleMailContentResponseAddTid(res[0], res[1], param))
            .then(res => this.getMailContentAssemble(res))
            .then(res => {
            if (!!param.subordinateFromAI && res.tpMailInfo) {
                res.tpMailInfo.subordinateFromAI = true;
            }
            return res;
        })
            .catch(reason => {
            console.warn(reason);
            return Promise.reject(this.commonCatch(reason));
        });
    }
    doGetResignMailContent(param) {
        const mid = param.resignMid;
        const url = `${this.systemApi.getUrl('resignReadMessage')}/${param.resignEmail}/${param.resignMid}`;
        const res = this.impl
            .get(url)
            .then((res) => {
            var _a;
            if (res && ((_a = res.data) === null || _a === void 0 ? void 0 : _a.data)) {
                res.data.data.sentDate = res.data.data.sentTime;
                return this.getMailContentProcessResponse(mid, res.data.data);
            }
            return Promise.reject(res.message);
        })
            .then((res) => {
            const newRes = res.map(item => (Object.assign(Object.assign({}, item), { isTpMail: false })));
            return this.handleMailContentResponse(newRes);
        });
        return res;
    }
    getMailContentProcessResponse(id, data, noContactRace = false, _account) {
        const prItem = this.contactHandler.mapMailEntryToProcessingItem(data, id);
        const promise = this.contactHandler.handleContactList([prItem], noContactRace, _account);
        const mailPartHtmlPromise = this.getMailContentPartProcessPromise(id, data);
        return Promise.all([mailPartHtmlPromise, promise]).then((contentRs) => {
            let htmlContent = '';
            if (contentRs[0] && contentRs[0].length > 0) {
                htmlContent = contentRs[0];
            }
            if (contentRs[1] && contentRs[1].length === 1) {
                const dd = contentRs[1][0];
                if (dd.html) {
                    dd.html.content = htmlContent;
                }
            }
            return contentRs[1];
        });
    }
    getMailContentMakeModelPromise(param) {
        const { id, noFlagInfo, noCache, ignoreContact = true, noContactRace = false, checkType, attrQuery, tpMids, _account } = param || {};
        return noFlagInfo
            ? Promise.resolve(this.buildEmptyMailEntryModel({ id, _account }, true))
            : this.mailApi
                .doListMailBoxEntities({
                mids: [id],
                count: 1,
                ignoreContact,
                noContactRace,
                checkType,
                attrQuery,
                tpMids: tpMids ? [tpMids] : undefined,
                _account: param._account,
            }, noCache)
                .then(result => {
                const res = Array.isArray(result) ? result : result.data;
                return res[0];
            });
    }
    getResignMailContentMakeModelPromise(param) {
        const { resignEmail, resignMid } = param || {};
        return this.mailApi
            .doListMailBoxEntities({
            isResign: true,
            resignEmail: resignEmail,
            resignMid: resignMid,
            _account: param._account,
        }, true)
            .then(result => {
            const res = Array.isArray(result) ? result : result.data;
            return res[0];
        });
    }
    getMailContentAssemble(res) {
        var _a, _b, _c, _d, _e;
        if (res && res[0] && res[1]) {
            const attachmentIllegal = this.modelHandler.getAttachmentsIllegal(res[0].entry.attachment, res[1].entry.attachment);
            if (attachmentIllegal > 0) {
                if (!res[0].mailIllegal) {
                    res[0].mailIllegal = [];
                }
                res[0].mailIllegal.push(attachmentIllegal);
            }
            const { entry } = res[0];
            entry.title = res[1].entry.title;
            entry.content = res[1].entry.content;
            entry.requestReadReceipt = res[1].entry.requestReadReceipt;
            entry.requestReadReceiptLocal = res[1].entry.requestReadReceipt;
            entry.attachment = res[1].entry.attachment;
            res[0].receiver = res[1].receiver;
            if (res[1].sender.originName !== '无发件人') {
                res[0].sender = res[1].sender;
                if (((_b = (_a = res[0]) === null || _a === void 0 ? void 0 : _a.senders) === null || _b === void 0 ? void 0 : _b.length) === 1 && ((_d = (_c = res[0]) === null || _c === void 0 ? void 0 : _c.senders[0]) === null || _d === void 0 ? void 0 : _d.originName) === '无发件人') {
                    res[0].senders = [res[1].sender];
                }
            }
            if ((_e = res[1]) === null || _e === void 0 ? void 0 : _e.scheduleDateTimeZone) {
                res[0].scheduleDateTimeZone = res[1].scheduleDateTimeZone;
            }
            res[0].headers = res[1].headers;
            res[0].antispamInfo = res[1].antispamInfo;
            res[0].isEncryptedMail = res[0].isEncryptedMail || res[1].isEncryptedMail;
            return res[0];
        }
        if (res[1]) {
            console.error('获取邮件内容时，未返回标示位对象');
            return res[1];
        }
        return Promise.reject({
            popupType: 'window',
            title: '未返回合适数据',
            code: 'SERVER.ERR',
        });
    }
    doListMailBoxEntities(param, noCache) {
        var _a, _b;
        if (!param) {
            return Promise.reject(new Error('需要传入查询参数'));
        }
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account: param._account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const hasSubEmails = Array.isArray(param.subEmails) && !!param.subEmails.filter(Boolean).length;
        if (param.id && (targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailBoxDic) && targetActions.mailBoxDic[param.id] && targetActions.mailBoxDic[param.id].locked && !hasSubEmails) {
            return Promise.reject(ErrResult.FA_NEED_AUTH2);
        }
        if ((process.env.BUILD_ISEDM || ((_b = this.systemApi.doGetProductInfo()) === null || _b === void 0 ? void 0 : _b.navigateVersion)) && param.checkType === 'checkCustomerMail') {
            return this.listCustomerMailEntry(param, noCache);
        }
        if (param.checkType === 'checkSubordinateMail') {
            return this.listSubordinateMailEntryNew(param, noCache);
        }
        if (!param.checkType || ['normal', 'checkStarMail'].includes(param.checkType)) {
            return this.listCommonMailEntry(param, noCache);
        }
        if (param.checkType === 'checkThread') {
            param._account = undefined;
            return this.listThreadMailEntry(param, noCache);
        }
        if (param.checkType === 'checkThreadDetail') {
            return this.getThreadMailDetails(param, noCache);
        }
        if (param.checkType === 'checkRelatedMail') {
            return this.getRelatedMail(param, noCache);
        }
        throw new Error('unknown error');
    }
    getThreadMailContentFromNetwork(threadId, params, noCache, _account) {
        const url = this.buildUrl('threadMailInfoDetail', undefined, undefined, _account);
        const req = this.buildThreadMailContentReq(threadId, params);
        return this.impl
            .post(url, req, {
            url,
            cachePolicy: 'noCache',
            noEnqueue: noCache,
            contentType: 'json',
            _account,
        })
            .then(res => {
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            if (isCorpMail) {
                corpMailUtils.corpMailTransformResponse(res);
            }
            return res;
        })
            .then(res => {
            const data = res.data;
            if (data.code === MailAbstractHandler.sOk && data.var) {
                return {
                    d: data.var,
                    t: data.total,
                };
            }
            if (data.code === 'FA_NEED_AUTH2') {
                return Promise.reject(ErrResult.FA_NEED_AUTH2);
            }
            return Promise.reject(this.getErrMsg(data.code));
        })
            .then(async (res) => {
            if (res.d && res.d.length > 0) {
                const responseMailListEntry = {
                    t: res.t,
                    d: this.handleThreadMailDetailEntryModel(res.d),
                };
                return this.handleListMailBoxEntities(req, responseMailListEntry, {
                    count: req.limit,
                    _account,
                }).then(res => setMailListAttSource(res, 'list'));
            }
            return [];
        });
    }
    buildThreadMailContentReq(threadId, params) {
        return {
            ids: [...new Set(threadId.map(v => v.split('--')[0]))],
            summaryWindowSize: params && params.summaryWindowSize ? params.summaryWindowSize : (params === null || params === void 0 ? void 0 : params.limit) || 50,
            order: params && params.order ? params.order : 'date',
            desc: params && params.desc !== undefined ? params.desc : false,
            returnTag: params && params.returnTag !== undefined ? params.returnTag : true,
            returnTotal: params && params.returnTotal !== undefined ? params.returnTotal : true,
            start: (params === null || params === void 0 ? void 0 : params.start) || 0,
            limit: (params === null || params === void 0 ? void 0 : params.limit) || 3000,
            returnConvInfo: (params === null || params === void 0 ? void 0 : params.returnConvInfo) !== undefined ? params.returnConvInfo : threadId.length > 1,
        };
    }
    getRelatedMail(param, _noCache) {
        var _a, _b;
        if (!param) {
            return Promise.reject(new Error('参数不合法'));
        }
        const currentUser = this.systemApi.getCurrentUser(param._account);
        if (!currentUser) {
            return Promise.reject(new Error('未登录？'));
        }
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (!isCorpMail) {
            return this.listCommonMailEntry(param, _noCache).then(res => res);
        }
        const url = this.impl.buildUrl(this.systemApi.getUrl('corpExchangeMails'), { sid: currentUser.sessionId });
        const emailList = [];
        if (param.relatedEmail) {
            emailList.push(...param.relatedEmail);
        }
        const flagVar = param.status === 'redFlag' ? 'FLAG' : param.status;
        const companyId = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _a === void 0 ? void 0 : _a.companyId;
        const emailCategory = param.status ? flagVar : 'ALL';
        const timestamp = param.startDate && param.startDate.length > 0 ? param.startDate : util.dateFormat(Date.now());
        const pageSize = param.count;
        const commonParams = {
            timestamp,
            offset: 0,
        };
        const reqParams = isCorpMail
            ? {
                companyId,
                contactList: emailList,
                emailCategory,
                pageSize,
            }
            : {
                company_id: (_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _b === void 0 ? void 0 : _b.companyId,
                contact_list: emailList,
                page_size: pageSize,
                email_category: emailCategory,
            };
        return this.impl
            .post(url, Object.assign(Object.assign({}, commonParams), reqParams), { contentType: 'json', _account: param._account })
            .then((res) => {
            var _a, _b, _c;
            console.log('[mail] related mail return from network :', res);
            if (isCorpMail) {
                corpMailUtils.corpMailTransformResponse(res);
            }
            if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.success) {
                const rs = (_b = res.data.data) === null || _b === void 0 ? void 0 : _b.emailInfoList;
                if (rs) {
                    const prItems = rs.map(item => this.contactHandler.mapMailEntryToProcessingItem(item, item.id));
                    return this.contactHandler.handleContactList(prItems).then((data) => {
                        var _a, _b;
                        const ret = [];
                        data.forEach(item => {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                            const receiver = item.receiver && item.receiver.length > 0 ? item.receiver : this.contactHandler.buildEmptyContact(true);
                            const sender = item.sender && item.sender.length > 0 ? item.sender : this.contactHandler.buildEmptyContact(false);
                            (_a = item.attachments) === null || _a === void 0 ? void 0 : _a.forEach((it) => {
                                it._account = param._account;
                            });
                            const attachment = this.handleAttachment(item.attachments, item.id);
                            ret.push({
                                id: item.id,
                                entry: {
                                    folder: item.fid || 0,
                                    top: (_b = item.flags) === null || _b === void 0 ? void 0 : _b.top,
                                    system: ((_c = item.flags) === null || _c === void 0 ? void 0 : _c.system) || false,
                                    popRead: ((_d = item.flags) === null || _d === void 0 ? void 0 : _d.popRead) || false,
                                    rcptSucceed: ((_e = item.flags) === null || _e === void 0 ? void 0 : _e.rcptSucceed) || false,
                                    rcptFailed: ((_f = item.flags) === null || _f === void 0 ? void 0 : _f.rcptFailed) || false,
                                    title: item.subject,
                                    sendTime: item.sentDate,
                                    receiveTime: item.receivedDate,
                                    mark: item.label0 === 1 ? 'redFlag' : 'none',
                                    attachmentCount: item.attachments ? item.attachments.length : 0,
                                    attachment,
                                    readStatus: ((_g = item.flags) === null || _g === void 0 ? void 0 : _g.read) ? 'read' : 'unread',
                                    brief: item.summary,
                                    replayed: (_h = item.flags) === null || _h === void 0 ? void 0 : _h.replied,
                                    forwarded: (_j = item.flags) === null || _j === void 0 ? void 0 : _j.forwarded,
                                    isDraft: (_k = item.flags) === null || _k === void 0 ? void 0 : _k.draft,
                                    isIcs: attachment === null || attachment === void 0 ? void 0 : attachment.some(it => it.fileType === 'ics'),
                                    canRecall: item.recallable,
                                    id: item.id,
                                    memo: item.memo,
                                    content: {
                                        content: '',
                                        contentId: '',
                                    },
                                    threadMessageIds: item.threadMessageIds,
                                    threadMessageCount: ((_l = item.threadMessageIds) === null || _l === void 0 ? void 0 : _l.length) || item.threadMessageCount || 0,
                                    rclStatus: item.rclStatus,
                                    sndStatus: item.sndStatus,
                                    sentMailId: item.sentMailId,
                                    suspiciousSpam: !!((_m = item.flags) === null || _m === void 0 ? void 0 : _m.suspiciousSpam),
                                },
                                receiver,
                                isOneRcpt: (_o = item.composeExtra) === null || _o === void 0 ? void 0 : _o.showOneRcpt,
                                senders: sender && sender.length > 0 ? sender : undefined,
                                sender: lodashGet(item, 'sender.0', {}),
                                totalSize: MailContentHandler.calculateTotalSize(item.attachments),
                                antispamInfo: item.antispamInfo,
                            });
                        });
                        ret.forEach(it => {
                            this.makeModelSafe(it);
                        });
                        return {
                            data: ret,
                            total: ret.length > 50 ? ret.length * 3 : ret.length,
                            index: param.index,
                            count: param.count,
                            additionalInfo: {
                                startDate: (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.timestamp,
                            },
                            query: param,
                        };
                    });
                }
            }
            return Promise.reject((_c = res.data) === null || _c === void 0 ? void 0 : _c.message);
        })
            .then(res => setMailListAttSource(res, 'list'));
    }
    getThreadMailDetails(param, noCache) {
        if (!param.mids) {
            return Promise.reject(new Error('需要传入查询参数,mids'));
        }
        return this.listThreadDetails(param.mids, noCache, param._account).then((res) => {
            if (res && res.length > 0) {
                return this.doListMailBoxEntities({
                    count: res.length,
                    mids: res,
                    returnModel: param.returnModel,
                    querySeq: param.querySeq,
                    _account: param._account,
                }, noCache);
            }
            return Promise.reject(new Error('无法获取数据'));
        });
    }
    doGetGroupMailStatus(id, noCache, _account) {
        const promise = this.listThreadDetails([id], noCache, _account);
        return promise
            .then((res) => this.doListMailBoxEntities({ count: res.length, mids: res, _account }))
            .then(result => MailContentHandler.calThreadMailStatus(result));
    }
    static calThreadMailStatus(result) {
        var _a, _b, _c;
        const res = Array.isArray(result) ? result : result.data;
        const re = Object.assign({}, res[0]);
        re.senders = re.senders ? re.senders : [re.sender];
        const map = {};
        const contacts = new Set([re.sender.contactItem.contactItemVal]);
        (_a = re.senders) === null || _a === void 0 ? void 0 : _a.forEach(it => {
            contacts.add(it.contactItem.contactItemVal);
        });
        re.entry.threadMessageCount = res.length;
        re.tags = Array.from(new Set(res
            .map(item => item.tags)
            .flat()
            .filter(item => item)));
        if (res && res.length > 1) {
            for (let i = 1; i < res.length; ++i) {
                re.entry.replayed = re.entry.replayed || res[i].entry.replayed;
                re.entry.forwarded = re.entry.forwarded || res[i].entry.forwarded;
                re.entry.readStatus = re.entry.readStatus === 'unread' ? re.entry.readStatus : res[i].entry.readStatus;
                re.entry.mark = re.entry.mark === 'redFlag' ? re.entry.mark : res[i].entry.mark;
                re.entry.isIcs = re.entry.isIcs || ((_b = res[i].entry.attachment) === null || _b === void 0 ? void 0 : _b.some(item => item.fileType === 'ics'));
                const { sender } = res[i];
                if (!contacts.has(sender.contactItem.contactItemVal)) {
                    (_c = re.senders) === null || _c === void 0 ? void 0 : _c.push(sender);
                    contacts.add(sender.contactItem.contactItemVal);
                }
                res[i].receiver.forEach(it => {
                    if (!map[it.contactItem.contactItemVal + it.mailMemberType]) {
                        map[it.contactItem.contactItemVal + it.mailMemberType] = '';
                        re.receiver.push(it);
                    }
                });
            }
        }
        return re;
    }
    listThreadDetails(mids, noCache, _account) {
        if (!mids) {
            throw new Error('参数错误');
        }
        if (mids.length === 1) {
            const id = mids[0];
            const urlKey = 'threadMailDetail';
            const url = this.buildUrl(urlKey, undefined, undefined, _account);
            const dt = { id };
            return this.impl
                .post(url, dt, this.getConfigForHttp(urlKey, {
                url,
                data: dt,
                method: 'post',
                cachePolicy: noCache ? 'refresh' : undefined,
                _account,
            }))
                .then(res => {
                var _a, _b;
                console.log('[mail] return from network:', res);
                const data = res.data;
                const ids = ((_a = data.var) === null || _a === void 0 ? void 0 : _a.map(it => it.id)) || [];
                const targetActions = (_b = this.mailApi.getActions({
                    actions: this.actions,
                    subActions: this.subActions,
                    _account,
                })) === null || _b === void 0 ? void 0 : _b.val;
                if (targetActions)
                    targetActions.threadMailIdMap[id] = ids;
                return ids;
            });
        }
        const ps = mids.map(it => this.listThreadDetails([it], noCache, _account));
        return Promise.all(ps).then((value) => value.reduce((ret, cur) => {
            if (cur && cur.length > 0) {
                cur.forEach(it => {
                    ret.push(it);
                });
            }
            return ret;
        }, []));
    }
    doCustomersUnread(param) {
        if (!Array.isArray(param.customerIds) || param.customerIds.length === 0) {
            return Promise.reject(new Error('缺少参数'));
        }
        const req = {
            companyIdList: param.customerIds,
            returnAll: param.returnAll === false ? 0 : 1,
        };
        const url = this.systemApi.getUrl('getCustomerMailUnread');
        return this.impl
            .post(url, req, {
            url,
            contentType: 'json',
            cachePolicy: 'noCache',
            noEnqueue: true,
        })
            .then(res => {
            const { data, code } = res.data;
            if (+code === 0 && data) {
                const customers = Array.isArray(data.customers) ? data.customers : [];
                const items = customers.map(v => {
                    const contacts = Array.isArray(v.contacts)
                        ? v.contacts.reduce((total, current) => {
                            const { contactId, email, num = 0, totalNum = 0 } = current;
                            if (!total[contactId]) {
                                total[contactId] = {
                                    contactId,
                                    email,
                                    unread: num,
                                    initialized: current.initialized,
                                    total: totalNum,
                                };
                            }
                            else {
                                total[contactId].unread = num;
                            }
                            return total;
                        }, {})
                        : {};
                    return {
                        customerId: v.customerId,
                        unread: v.num || 0,
                        contacts,
                        initialized: v.initialized,
                        total: v.totalNum || 0,
                    };
                });
                return {
                    total: data.num,
                    items,
                    initialized: data.initialized,
                };
            }
            return Promise.reject(this.getErrMsg(code));
        });
    }
    doCustomersUnreadTotal() {
        const url = this.systemApi.getUrl('getCustomerMailUnread');
        const req = {
            returnAll: 1,
        };
        return this.impl
            .post(url, req, {
            url,
            contentType: 'json',
            cachePolicy: 'noCache',
            noEnqueue: true,
        })
            .then(res => {
            const { data, code } = res.data;
            if (+code === 0 && data) {
                return {
                    total: data.num || 0,
                    initialized: data.initialized,
                };
            }
            return Promise.reject(this.getErrMsg(code));
        });
    }
    async getSharedAccountsUnread() {
        var _a;
        const url = this.systemApi.getUrl('getPubRelationUnreadCounts');
        try {
            const apiRet = await this.impl.post(url);
            const res = apiRet === null || apiRet === void 0 ? void 0 : apiRet.data;
            if (!res || res.code !== 200 || !((_a = res.result) === null || _a === void 0 ? void 0 : _a.unreadCounts)) {
                return {};
            }
            const map = {};
            const unreadCounts = res.result.unreadCounts;
            Object.keys(unreadCounts).forEach(email => {
                const item = unreadCounts[email];
                if (item && item.suc && typeof item.unreadCount === 'number') {
                    map[email] = item.unreadCount;
                }
            });
            return map;
        }
        catch (e) {
            console.error('[getSharedAccountsUnread] error', e);
            return {};
        }
    }
    listCustomerMailEntry(param, noCache) {
        const { attrQuery, attrQueryFilter } = param;
        if (!attrQuery || (Array.isArray(attrQuery) && attrQuery.length === 0)) {
            return Promise.reject(new Error('查询客户邮件时缺少 Attr 参数'));
        }
        const queryList = Array.isArray(attrQuery) ? attrQuery : [attrQuery];
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser) {
            return Promise.reject(new Error('未登录'));
        }
        const url = this.systemApi.getUrl('getCustomerMail');
        const searchItems = queryList.map(v => ({
            from: v.from || currentUser.id,
            toList: (Array.isArray(v.to) ? v.to : [v.to]).filter(it => !!it),
        }));
        const req = {
            searchItems,
            exchangeType: (attrQueryFilter === null || attrQueryFilter === void 0 ? void 0 : attrQueryFilter.type) || 'all',
            limitAll: param.count,
            endTime: param.endDate || '',
            mid: param.endMid || '',
        };
        return this.listEdmMailEntry(param, { url, req, noCache }).then(res => setMailListAttSource(res, 'list'));
    }
    async listSubordinateMailEntryNew(param, noCache) {
        const urlKey = MailContentHandler.getListMailBoxEntryUrl(param);
        const cacheInfo = 'noCache';
        const cachePolicy = noCache ? cacheInfo : undefined;
        const req = await this.buildListEntryReq(param);
        const urlParam = {
            colleagueAccId: param.subordinateId,
            onlyMountAccount: !param.subEmails || param.subEmails.length === 1,
            allColleague: param.subordinateId === 'allColleague' || param.subordinateId === 'allSubordinate',
        };
        if (param.subordinateId === 'allColleague' || param.subordinateId === 'allSubordinate') {
            delete urlParam.colleagueAccId;
        }
        const url = this.impl.buildUrl(this.systemApi.getUrl(process.env.BUILD_ISEDM ? 'getColleagueListMessages' : 'getLxColleagueListMessages'), urlParam);
        const midToColleagueAccIdMap = new Map();
        return this.impl
            .post(url, req, this.getConfigForHttp(urlKey, {
            url,
            data: req,
            method: 'post',
            responseType: 'text',
            expectedResponseType: 'json',
            cachePolicy,
            noEnqueue: noCache,
            _account: param === null || param === void 0 ? void 0 : param._account,
        }))
            .then(res => {
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            if (isCorpMail) {
                corpMailUtils.corpMailTransformResponse(res);
            }
            console.log('[mail] return from network:', res);
            const { data } = res;
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                const d = data.data.messageInfos.map((item) => {
                    item.colleagueAccId = item.owner || param.subordinateId;
                    delete item.owner;
                    midToColleagueAccIdMap.set(item.id, item.colleagueAccId);
                    return item;
                });
                return {
                    d,
                    t: data.data.total,
                    b: 0,
                };
            }
            return Promise.reject(new Error('获取下属邮件列表失败'));
        })
            .then(async (res) => this.handleListMailBoxEntities(req, res, param))
            .then(res => {
            const result = res;
            if ((result === null || result === void 0 ? void 0 : result.data) && !!(result === null || result === void 0 ? void 0 : result.data.length)) {
                result.data = result.data.map(m => (Object.assign(Object.assign({}, m), { mailFrom: 'subordinate', tpMailInfo: {
                        colleagueAccId: midToColleagueAccIdMap.get(m.id),
                        belongEmail: m.owner,
                    }, isTpMail: true })));
            }
            return result;
        });
    }
    listEdmMailEntry(param, conf) {
        param.returnModel = true;
        const { url, req, noCache } = conf;
        let over = false;
        return this.impl
            .post(url, req, {
            url,
            contentType: 'json',
            cachePolicy: noCache ? 'noCache' : undefined,
            noEnqueue: noCache,
        })
            .then(res => {
            const { data, code } = res.data;
            if (+code === 0 && data) {
                over = data.over;
                if (data.emailInfos) {
                    const deleteInfo = param.checkType === 'checkCustomerMail' ? data.notPartner : data.notColleague;
                    if (Array.isArray(deleteInfo) && deleteInfo.length > 0) {
                        console.warn('[listCustomerMailEntry] no permission', deleteInfo);
                        this.mailDbHandler.deleteTpMailsByOwner(deleteInfo).then();
                    }
                    return {
                        d: data.emailInfos,
                        t: data.emailInfos.length === 0 ? 0 : data.emailInfos.length,
                    };
                }
                return {
                    d: [],
                    t: 0,
                };
            }
            return Promise.reject(this.getErrMsg(code));
        })
            .then((res) => this.handleListMailBoxEntities(Object.assign(Object.assign({}, req), { start: 0, limit: param.count, summaryWindowSize: param.count }), res, param))
            .then(res => {
            if (res.data && res.data.length) {
                res.data.forEach(it => {
                    it.mailFrom = 'customer';
                });
            }
            return res;
        })
            .then(res => (Object.assign(Object.assign({}, res), { over })));
    }
    async listCustomerMailEntryByIdOld(param, checkType = 'checkCustomerMail') {
        const count = param.reduce((t, v) => t + v.mids.length, 0);
        const url = this.impl.buildUrl(this.systemApi.getUrl(process.env.BUILD_ISEDM ? 'checkTpMailExist' : 'checkLxTpMailExist'), { type: param[0].type }, { noAddingHost: true });
        const req = {
            emails: param,
        };
        return this.impl
            .post(url, req, {
            url,
            contentType: 'json',
        })
            .then(res => {
            const { data, code } = res.data;
            if (+code === 0 && data && Array.isArray(data === null || data === void 0 ? void 0 : data.emailInfos)) {
                data.emailInfos.forEach(v => {
                    v.mainAccount = param[0].mainAccount;
                });
                return {
                    d: data.emailInfos,
                    t: data.emailInfos.length === 0 ? 0 : data.emailInfos.length,
                };
            }
            return Promise.reject(this.getErrMsg(code));
        })
            .then((res) => this.handleListMailBoxEntities({
            start: 0,
            limit: count,
            summaryWindowSize: count,
        }, res, { checkType, count, noContactRace: true }));
    }
    async listCustomerMailEntryById(param, checkType = 'checkCustomerMail', colleagueAccId) {
        if (!colleagueAccId) {
            return this.listCustomerMailEntryByIdOld(param, checkType);
        }
        const count = param.reduce((t, v) => t + v.mids.length, 0);
        const url = this.impl.buildUrl(this.systemApi.getUrl('checkTpMailExistNew'), {
            colleagueAccId,
        });
        const req = {
            list: param,
        };
        return this.impl
            .post(url, req, {
            url,
            contentType: 'json',
        })
            .then(res => {
            const { data, code } = res.data;
            if (+code === 0 && data && Array.isArray(data === null || data === void 0 ? void 0 : data.emailInfos)) {
                return {
                    d: data.emailInfos,
                    t: data.emailInfos.length === 0 ? 0 : data.emailInfos.length,
                };
            }
            return Promise.reject(this.getErrMsg(code));
        })
            .then((res) => this.handleListMailBoxEntities({
            start: 0,
            limit: count,
            summaryWindowSize: count,
        }, res, { checkType, count, noContactRace: true }))
            .then((res) => {
            const oldData = Array.isArray(res) ? res : res.data;
            oldData.forEach(v => {
                v.isTpMail = true;
                v.tpMailInfo = {
                    colleagueAccId,
                    belongEmail: v.owner,
                };
            });
            return res;
        });
    }
    async listResignMailEntryById(param) {
        const resignMid = param.resignMid;
        const resignEmail = param.resignEmail;
        const url = this.impl.buildUrl(`${this.systemApi.getUrl('resignMessageInfos')}/${resignEmail}/${resignMid}`, {});
        return this.impl
            .get(url)
            .then(res => {
            const { data, code } = res.data;
            if (+code === 200 && Array.isArray(data)) {
                return {
                    d: data,
                    t: data.length === 0 ? 0 : data.length,
                };
            }
            return Promise.reject(this.getErrMsg(code));
        })
            .then((res) => this.handleListMailBoxEntities({
            start: 0,
            limit: 1,
            summaryWindowSize: 1,
        }, res, { checkType: 'normal', count: 1, noContactRace: true }))
            .then((res) => {
            const oldData = Array.isArray(res) ? res : res.data;
            oldData.forEach(v => {
            });
            return res;
        });
    }
    async listCommonMailEntry(param, noCache) {
        if (param.id === FLOLDER.CUSTOMER_UNFOLLOW || param.id === FLOLDER.UNFOLLOW) {
            return this.listCommonMailEntryOfFollowUp(param, noCache);
        }
        if (param.mids && param.mids.length > 100) {
            const params = [];
            const max = param.mids.length < 2000 ? param.mids.length : 2000;
            for (let i = 0; i * 100 < max; ++i) {
                params.push(Object.assign(Object.assign({}, param), { mids: param.mids.slice(i * 100, i * 100 + 99) }));
            }
            const promises = params.map(it => this.listCommonMailEntry(it, noCache).then(result => (Array.isArray(result) ? result : result.data)));
            return Promise.all(promises)
                .then((res) => {
                const mailEntryModels = res.reduce((current, item) => {
                    item.forEach(it => {
                        current.push(it);
                    });
                    return current;
                }, []);
                if (param.returnModel) {
                    return {
                        data: mailEntryModels,
                        total: mailEntryModels.length,
                        index: 0,
                        count: mailEntryModels.length,
                        query: param,
                    };
                }
                return mailEntryModels;
            })
                .then(res => setMailListAttSource(res, 'list'));
        }
        if ((param.mids && param.mids.length <= 100) || !param.mids) {
            if (param.mids && param.mids.length === 0) {
                return Promise.resolve(param.returnModel ? { data: [], total: 0 } : []);
            }
            const urlKey = MailContentHandler.getListMailBoxEntryUrl(param);
            const additionalParam = param._account ? this.getAccountSession(param._account) : undefined;
            const url = this.buildUrl(urlKey, additionalParam, !!(additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam._session), param._account);
            const req = await this.buildListEntryReq(param);
            param.addSentContent = !param.mids && param.id === mailBoxOfSent.id;
            const cacheInfo = 'noCache';
            const cachePolicy = noCache ? cacheInfo : undefined;
            return this.impl
                .post(url, req, this.getConfigForHttp(urlKey, {
                url,
                data: req,
                method: 'post',
                responseType: 'text',
                expectedResponseType: 'json',
                cachePolicy,
                noEnqueue: noCache,
                _account: param === null || param === void 0 ? void 0 : param._account,
            }))
                .then(res => {
                const isCorpMail = this.systemApi.getIsCorpMailMode();
                if (isCorpMail) {
                    corpMailUtils.corpMailTransformResponse(res);
                }
                console.log('[mail] return from network:', res);
                const data = res.data;
                if (data.code === MailAbstractHandler.sOk && data.var) {
                    return {
                        d: data.var,
                        t: data.total,
                        b: data.building === true ? 1 : 0,
                    };
                }
                if (data.code === 'FA_NEED_AUTH2') {
                    return Promise.reject(ErrResult.FA_NEED_AUTH2);
                }
                return Promise.reject(this.getErrMsg(data.code));
            })
                .then((res) => this.handleListMailBoxEntities(req, res, param));
        }
        throw new Error('请求过于庞大，请稍后再试');
    }
    async listCommonMailEntryOfFollowUp(param, noCache) {
        const req = await this.buildListEntryReq(param);
        const reqData = {
            isMultiple: param.subEmails && !!param.subEmails.length,
            type: param.id === FLOLDER.CUSTOMER_UNFOLLOW ? 'customer' : 'nonCustomer',
            lastMid: !!(param === null || param === void 0 ? void 0 : param.index) ? param.startId || '' : '',
            limit: param.count,
        };
        if (param.subEmails && param.subEmails.length > 1) {
            reqData.subEmails = param.subEmails;
        }
        else {
            reqData.subEmails = [param._account];
            reqData.isMultiple = false;
        }
        try {
            const httpApi = api.getDataTransApi();
            const currentUser = this.systemApi.getCurrentUser();
            const node = this.storeApi.getCurrentNode();
            const url = this.impl.buildUrl(this.systemApi.getUrl('getMailListOfCustomerUnFollow'), { sid: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) || '', node });
            return httpApi
                .post(url, reqData, { contentType: 'json' })
                .then(res => {
                const data = res.data;
                if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                    const inData = data.data;
                    if (inData.code === MailAbstractHandler.sOk && inData.var) {
                        const d = inData.var.map(item => {
                            var _a;
                            delete item.owner;
                            item.belongEmail = ((_a = this.systemApi.getCurrentUser(item.belongEmail)) === null || _a === void 0 ? void 0 : _a.id) || item.belongEmail;
                            return item;
                        });
                        return {
                            d,
                            t: inData.total,
                            b: inData.building === true ? 1 : 0,
                        };
                    }
                    if (inData.code === 'FA_NEED_AUTH2') {
                        return Promise.reject(ErrResult.FA_NEED_AUTH2);
                    }
                }
                return Promise.reject(this.getErrMsg(data === null || data === void 0 ? void 0 : data.data.code));
            })
                .then((res) => this.handleListMailBoxEntities(req, res, param))
                .then((res) => {
                const oldData = Array.isArray(res) ? res : res.data;
                oldData.forEach(v => {
                    v.entry.isFollowUp = false;
                });
                return res;
            });
        }
        catch (e) {
            console.error('[mail_content_handle] listCommonMailEntryOfFollowUp error', e);
        }
        throw new Error('请求过于庞大，请稍后再试');
    }
    async listThreadMailEntry(param, noCache) {
        const url = this.buildUrl('threadMailList');
        const req = await this.buildThreadListEntryReq(param);
        return this.impl
            .post(url, req, {
            url,
            cachePolicy: 'noCache',
            noEnqueue: noCache,
            contentType: 'json',
        })
            .then(res => {
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            if (isCorpMail) {
                corpMailUtils.corpMailTransformResponse(res);
            }
            return res;
        })
            .then(res => {
            const data = res.data;
            if (data.code === MailAbstractHandler.sOk && data.var) {
                return {
                    d: data.var,
                    t: data.total,
                    b: data.building ? 1 : 0,
                };
            }
            if (data.code === 'FA_NEED_AUTH2') {
                return Promise.reject(ErrResult.FA_NEED_AUTH2);
            }
            return Promise.reject(this.getErrMsg(data.code));
        })
            .then((res) => {
            const responseMailListEntry = {
                t: res.t,
                d: this.handleThreadMailEntryModel(res.d),
                b: res.b,
            };
            return this.handleListMailBoxEntities(req, responseMailListEntry, param).then(res => setMailListAttSource(res, 'list'));
        });
    }
    handleThreadMailEntryModel(data) {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        return data.map(v => {
            var _a;
            const cid = v.convId ? String(v.convId) : v.id;
            const mid = isCorpMail ? v.id : cid;
            return {
                isThread: !!v.convId,
                id: mid,
                convFids: Array.isArray(v.convFids) ? v.convFids : undefined,
                threadId: isCorpMail ? v.id : String(v.convId),
                threadMessageFirstId: v.id,
                threadMessageCount: v.threadMessageCount || 0,
                threadMessageIds: Array.isArray(v.threadMessageIds) ? v.threadMessageIds : [],
                attachments: Array.isArray(v.attachments) ? v.attachments : [],
                subject: v.subject,
                priority: v.priority,
                from: typeof v.from === 'string' ? v.from.split(',') : v.from,
                to: v.to,
                cc: Array.isArray(v.cc) ? v.cc : [],
                bcc: Array.isArray(v.bcc) ? v.bcc : [],
                replyTo: Array.isArray(v.replyTo) ? v.replyTo : [],
                flags: v.flags,
                memo: v.memo,
                fid: v.fid,
                summary: v.summary,
                backgroundColor: v.backgroundColor,
                antiVirusStatus: v.antiVirusStatus,
                label0: v.label0,
                systemLabel: v.systemLabel,
                size: v.size,
                encpwd: v.encpwd,
                recallable: v.recallable,
                modifiedDate: v.modifiedDate || '',
                tag: v.tag,
                sentDate: v.sentDate || '',
                receivedDate: v.receivedDate || '',
                tid: v.tid,
                eTeamType: v.eTeamType || 0,
                suspiciousSpam: !!((_a = v.flags) === null || _a === void 0 ? void 0 : _a.suspiciousSpam),
            };
        });
    }
    handleThreadMailDetailEntryModel(data) {
        return data.map(v => {
            var _a;
            return ({
                isThread: !!v.convId,
                id: v.convId ? String(v.convId) : v.id,
                convFids: Array.isArray(v.convFids) ? v.convFids : undefined,
                threadId: v.convId ? String(v.convId) : undefined,
                threadMessageCount: v.threadMessageCount || undefined,
                threadMessageIds: Array.isArray(v.threadMessageIds) ? v.threadMessageIds : undefined,
                attachments: Array.isArray(v.attachments) ? v.attachments : [],
                subject: v.subject,
                priority: v.priority,
                from: v.from,
                to: v.to,
                cc: Array.isArray(v.cc) ? v.cc : [],
                bcc: Array.isArray(v.bcc) ? v.bcc : [],
                replyTo: Array.isArray(v.replyTo) ? v.replyTo : [],
                flags: v.flags,
                memo: v.memo,
                fid: v.fid,
                summary: v.summary,
                backgroundColor: v.backgroundColor,
                antiVirusStatus: v.antiVirusStatus,
                label0: v.label0,
                systemLabel: v.systemLabel,
                size: v.size,
                encpwd: v.encpwd,
                recallable: v.recallable,
                modifiedDate: v.modifiedDate || '',
                tag: v.tag,
                sentDate: v.sentDate || '',
                sentMailId: v.sentMailId || '',
                receivedDate: v.receivedDate || '',
                taskId: v.taskId,
                tid: v.tid,
                eTeamType: v.eTeamType || 0,
                suspiciousSpam: !!((_a = v.flags) === null || _a === void 0 ? void 0 : _a.suspiciousSpam),
            });
        });
    }
    setupLastMailBoxEntry(req, result) {
        var _a, _b, _c, _d;
        if (result && req && req.fid && req.start === 0 && !req.ids && !((_a = req.filter) === null || _a === void 0 ? void 0 : _a.label0) && !((_b = req.filter) === null || _b === void 0 ? void 0 : _b.flags) && !((_c = req.filter) === null || _c === void 0 ? void 0 : _c.read)) {
            const targetActions = (_d = this.mailApi.getActions({
                actions: this.actions,
                subActions: this.subActions,
                _account: result._account,
            })) === null || _d === void 0 ? void 0 : _d.val;
            const confs = targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailBoxDic;
            if (confs && typeof req.fid === 'number' && Object.prototype.hasOwnProperty.call(confs, Number(req.fid)) && confs[Number(req.fid)]) {
                const item = confs[req.fid];
                item.latestMailEntry = result;
            }
        }
    }
    handleListMailBoxEntities(req, result, param, search) {
        const res = result.d;
        const { _account } = param;
        const prItems = res.map(item => this.contactHandler.mapMailEntryToProcessingItem(item, item.id));
        if (param.ignoreContact || res.length === 0) {
            return Promise.resolve(this.handleEntryListRet({
                req,
                data: prItems,
                param,
                total: result.t,
                search,
                building: result.b,
            }));
        }
        return this.contactHandler
            .handleContactList(prItems, param.noContactRace, _account)
            .then((contactRs) => this.handleEntryListRet({
            req,
            data: contactRs,
            param,
            total: result.t,
            search,
            building: result.b,
        }))
            .catch(reason => {
            console.log('[mail] mail entry get contact error:', reason);
            return this.handleEntryListRet({
                req,
                data: prItems,
                param,
                total: result.t,
                search,
                building: result.b,
            });
        });
    }
    openFilehandleAttachment(attachments, mid, params) {
        return this.handleAttachment(attachments, mid, params);
    }
    handleEntryListRet(conf) {
        const { req, data, param, total, search, building } = conf;
        const { _account } = param || {};
        const ret = [];
        if (search) {
            this.modelHandler.checkAllFailToSendMails(param, ret, search);
        }
        const user = this.systemApi.getCurrentUser(_account);
        data.forEach(item => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
            const receiver = item.receiver && item.receiver.length > 0 ? item.receiver : this.contactHandler.buildEmptyContact(true);
            const sender = item.sender && item.sender.length > 0 ? item.sender : this.contactHandler.buildEmptyContact(false);
            let { owner } = item;
            (_a = item.attachments) === null || _a === void 0 ? void 0 : _a.forEach((it) => {
                it._account = _account;
            });
            if (param.checkType === 'checkSubordinateMail') {
                if (!owner) {
                    owner = item.belongEmail;
                }
                if (!owner && param.subEmails && param.subEmails.length === 1) {
                    owner = param.subEmails[0];
                }
            }
            let isTpMail = !!owner && (user === null || user === void 0 ? void 0 : user.id) !== owner;
            if (param.checkType === 'checkCustomerMail' && item.mainAccount === (user === null || user === void 0 ? void 0 : user.id)) {
                isTpMail = false;
            }
            const attachment = this.handleAttachment(item.attachments, item.id, {
                isTpMail,
                owner,
                tid: item.tid,
                colleagueAccId: item.colleagueAccId || param.subordinateId,
                mailFrom: param.checkType === 'checkCustomerMail' ? 'customer' : undefined,
            });
            const isEncryptedMail = attachment ? getIsEncryptedMail(attachment) : false;
            let belongAccount;
            if (param.checkType !== 'checkSubordinateMail' && Array.isArray(param === null || param === void 0 ? void 0 : param.subEmails) && (param === null || param === void 0 ? void 0 : param.subEmails.filter(Boolean).length) > 0) {
                belongAccount = item === null || item === void 0 ? void 0 : item.belongEmail;
            }
            else if (param.checkType == 'checkCustomerMail') {
                belongAccount = item.owner;
            }
            const _tags = item.tag || [];
            if (_tags && (process.env.BUILD_ISEDM || ((_b = this.systemApi.doGetProductInfo()) === null || _b === void 0 ? void 0 : _b.navigateVersion)) && item.systemLabel && item.systemLabel.length) {
                if (item.systemLabel.includes(3) && !_tags.includes('__deliveryrecord__')) {
                    _tags.unshift('__deliveryrecord__');
                }
                if (item.systemLabel.includes(4) && !_tags.includes('__delivery__')) {
                    _tags.unshift('__delivery__');
                }
            }
            ret.push({
                isThread: !!item.isThread,
                threadId: item.threadId ? item.threadId : '',
                id: item.isThread && item.threadId ? item.threadId : item.id,
                convFids: item.isThread && Array.isArray(item.convFids) ? item.convFids : undefined,
                _account: belongAccount || (user === null || user === void 0 ? void 0 : user.id),
                entry: {
                    folder: item.fid || 0,
                    top: (_c = item.flags) === null || _c === void 0 ? void 0 : _c.top,
                    system: ((_d = item.flags) === null || _d === void 0 ? void 0 : _d.system) || false,
                    popRead: ((_e = item.flags) === null || _e === void 0 ? void 0 : _e.popRead) || false,
                    rcptSucceed: ((_f = item.flags) === null || _f === void 0 ? void 0 : _f.rcptSucceed) || false,
                    rcptFailed: ((_g = item.flags) === null || _g === void 0 ? void 0 : _g.rcptFailed) || false,
                    title: this.htmlApi.encodeHtml(item.subject),
                    sendTime: item.sentDate,
                    receiveTime: item.receivedDate,
                    mark: item.label0 === 1 ? 'redFlag' : 'none',
                    attachmentCount: item.attachments ? item.attachments.length : 0,
                    attachment,
                    readStatus: ((_h = item.flags) === null || _h === void 0 ? void 0 : _h.read) ? 'read' : 'unread',
                    brief: item.summary ? this.htmlApi.encodeHtml(item.summary) : undefined,
                    replayed: (_j = item.flags) === null || _j === void 0 ? void 0 : _j.replied,
                    forwarded: (_k = item.flags) === null || _k === void 0 ? void 0 : _k.forwarded,
                    directForwarded: (_l = item.flags) === null || _l === void 0 ? void 0 : _l.directForwarded,
                    isDraft: (_m = item.flags) === null || _m === void 0 ? void 0 : _m.draft,
                    isIcs: attachment === null || attachment === void 0 ? void 0 : attachment.some(it => (it === null || it === void 0 ? void 0 : it.fileType) === 'ics'),
                    canRecall: item.recallable,
                    id: item.id,
                    memo: item.memo,
                    content: {
                        content: '',
                        contentId: '',
                    },
                    threadMessageFirstId: item.isThread && item.threadMessageFirstId ? item.threadMessageFirstId : undefined,
                    threadMessageIds: item.isThread && item.threadMessageIds ? item.threadMessageIds : undefined,
                    threadMessageCount: item.isThread && item.threadMessageCount ? item.threadMessageCount : 0,
                    rclStatus: item.rclStatus,
                    sndStatus: item.sndStatus,
                    isScheduleSend: ((_o = item.flags) === null || _o === void 0 ? void 0 : _o.scheduleDelivery) || false,
                    priority: item.priority,
                    tid: item.tid,
                    rcptCount: item.rcptCount,
                    readCount: item.readCount,
                    innerCount: item.innerCount,
                    innerRead: item.innerRead,
                    preferred: item.preferred === 0 ? 0 : 1,
                    praiseId: item.praiseId ? item.praiseId : undefined,
                    sentMailId: item.sentMailId,
                    requestReadReceipt: item.requestReadReceipt,
                    langType: item.langType || '',
                    langListMap: item.langListMap || {},
                    eTeamType: item.eTeamType || 0,
                    isDefer: !!((_p = item.flags) === null || _p === void 0 ? void 0 : _p.deferHandle),
                    deferTime: ((_q = item.flags) === null || _q === void 0 ? void 0 : _q.deferHandle) ? item.defer || NoSetDeferTime : undefined,
                    deferNotice: item.deferNotice,
                    linkAttached: !!((_r = item.flags) === null || _r === void 0 ? void 0 : _r.linkAttached),
                    suspiciousSpam: !!((_s = item.flags) === null || _s === void 0 ? void 0 : _s.suspiciousSpam),
                    encpwd: item.encpwd || '',
                    systemLabel: item.systemLabel,
                    tr_org_ec_id: (_t = item === null || item === void 0 ? void 0 : item.ctrls) === null || _t === void 0 ? void 0 : _t.tr_org_ec_id,
                    wmReply: item.wmReply || 0,
                    mTrack: !!((_u = item.flags) === null || _u === void 0 ? void 0 : _u.mTrack),
                    approvalStatus: item.approvalStatus,
                },
                receiver,
                isOneRcpt: (_v = item.composeExtra) === null || _v === void 0 ? void 0 : _v.showOneRcpt,
                senders: sender && sender.length > 0 ? sender : undefined,
                sender: lodashGet(item, 'sender.0', {}),
                totalSize: MailContentHandler.calculateTotalSize(item.attachments),
                tags: _tags,
                taskId: item === null || item === void 0 ? void 0 : item.taskId,
                isTpMail,
                owner,
                mainAccount: item.mainAccount,
                size: item.size,
                isEncryptedMail,
            });
        });
        ret.forEach(it => {
            this.makeModelSafe(it);
        });
        this.setupLastMailBoxEntry(req, ret[0]);
        if (param.returnModel) {
            return {
                data: ret,
                total,
                index: param.index,
                count: param.count,
                query: param,
                building,
            };
        }
        return ret;
    }
    static getListMailBoxEntryUrl(param) {
        if (param.checkType && param.checkType === 'checkThread') {
            return 'threadMail';
        }
        if (param.checkType && param.checkType === 'checkThreadDetail') {
            return 'threadMailDetail';
        }
        return param.mids ? 'getContentByIds' : 'listItem';
    }
    async buildListEntryReq(param) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const target = {
            limit: param.count,
            summaryWindowSize: param.count,
            filter: param.filter || {},
        };
        const hasSubEmails = Array.isArray(param.subEmails) && param.subEmails.filter(Boolean).length > 0;
        if (hasSubEmails) {
            target.subEmails = (_a = param.subEmails) === null || _a === void 0 ? void 0 : _a.filter(Boolean);
        }
        if (param.tag) {
            target.tag = param.tag;
            target.fids = this.getFids(true, param._account);
            target.skipLockedFolders = true;
        }
        if (param.startId) {
            target.offsetmid = param.startId;
        }
        if (param.index) {
            target.start = param.index;
        }
        if (param.topFlag) {
            target.topFlag = param.topFlag;
        }
        if (param.id === mailBoxOfDefer.id) {
            delete target.fid;
            target.desc = false;
            target.order = 'deferredDate';
            target.filter = Object.assign(Object.assign({}, target.filter), { defer: ((_b = param.filter) === null || _b === void 0 ? void 0 : _b.defer) || ':22000101' });
            target.skipLockedFolders = true;
        }
        if (param.order) {
            target.order = param.order;
            target.desc = !!param.desc;
            if ((_c = param.filter) === null || _c === void 0 ? void 0 : _c.sentDate) {
                target.filter = Object.assign(Object.assign({}, target.filter), { sentDate: `${(_d = param.filter) === null || _d === void 0 ? void 0 : _d.sentDate[0].replace(/-/g, '')}:${(_e = param.filter) === null || _e === void 0 ? void 0 : _e.sentDate[1].replace(/-/g, '')}` });
            }
        }
        if (param.mids && param.mids.length > 0) {
            if (!param.checkType || param.checkType === 'normal') {
                target.ids = param.mids.filter(it => !it.endsWith('-tmp'));
            }
            else if (param.checkType && param.checkType === 'checkThreadDetail') {
                target.id = param.mids[0];
            }
        }
        if (param.checkType === 'checkThread') {
            target.mode = param.mode || 'listid';
        }
        if (!param.mids || param.mids.length === 0) {
            let checkRed = false;
            if (param.ids && param.ids.length > 0) {
                target.fids = param.ids.filter(it => it > 0);
            }
            else if (param.id && param.id > 0) {
                target.fid = param.id;
            }
            else if (param.checkType === 'checkSubordinateMail' && (param.id === mailBoxOfCustomerUnFollow.id || param.id === mailBoxOfUnFollow.id)) {
                target.fid = param.id;
            }
            else if (param.id === mailBoxOfRdFlag.id) {
                target.fids = (_f = this.getFids(true, param._account)) === null || _f === void 0 ? void 0 : _f.filter((id) => id !== 4 && id !== 5);
                target.filter = Object.assign(target.filter, {
                    label0: 1,
                });
                checkRed = true;
                if (hasSubEmails) {
                    delete target.fids;
                }
            }
            else if (param.id === mailBoxOfUnread.id) {
                target.fids = (_g = this.getFids(false, param._account)) === null || _g === void 0 ? void 0 : _g.filter((id) => id > 0 && id !== 4 && id !== 5 && id !== 2 && id !== 3);
                if ((target.fids && target.fids.length > 1000) || hasSubEmails) {
                    delete target.fids;
                }
                target.filter = Object.assign(target.filter, {
                    flags: Object.assign(Object.assign({}, (_h = target === null || target === void 0 ? void 0 : target.filter) === null || _h === void 0 ? void 0 : _h.flags), { read: false }),
                });
                checkRed = true;
            }
            else if (param.checkType === 'checkStarMail') {
                if (!param.attrConf) {
                    const attrConf = await this.modelHandler.doGetStarContactQuery(param.id);
                    param.attrConf = Object.assign(Object.assign({}, attrConf), { attrType: 'star' });
                }
                const { emailList } = param.attrConf;
                if (emailList.length > 0) {
                    target.filter = Object.assign(target.filter, {
                        starredWithAddress: [...new Set(emailList)],
                        selfSend: null,
                    });
                    if (param.attrQueryFilter) {
                        target.filter = Object.assign(target.filter, {
                            selfSend: param.attrQueryFilter.type === 'send',
                        });
                    }
                }
                target.skipLockedFolders = true;
                if (((_j = param.filter) === null || _j === void 0 ? void 0 : _j.read) !== undefined) {
                    target.filter = Object.assign(target.filter, {
                        flags: { read: (_k = param.filter) === null || _k === void 0 ? void 0 : _k.read },
                    });
                }
            }
            if (checkRed) {
                target.skipLockedFolders = true;
            }
            if (param.checkType === 'checkRelatedMail') {
                target.skipLockedFolders = true;
                if (param.relatedEmail) {
                    target.filter = Object.assign(target.filter, {
                        chatWithAddress: [...param.relatedEmail],
                    });
                }
            }
            if (param.checkType === 'checkSubordinateMail') {
                target.skipLockedFolders = true;
            }
            if (param.status) {
                switch (param.status) {
                    case 'spam':
                        break;
                    case 'redFlag':
                        if (!checkRed) {
                            const extraFilter = param.checkType === 'checkRelatedMail' ? { flags: { flagged: true } } : { label0: 1 };
                            target.filter = Object.assign(target.filter, extraFilter);
                        }
                        break;
                    case 'read':
                        target.filter = Object.assign(target.filter, {
                            read: true,
                        });
                        break;
                    case 'unread':
                        target.filter = Object.assign(target.filter, {
                            read: false,
                        });
                        break;
                    case 'SENT':
                        target.filter = Object.assign(target.filter, {
                            selfSend: true,
                        });
                        break;
                    case 'RECEIVED':
                        target.filter = Object.assign(target.filter, {
                            selfSend: false,
                        });
                        break;
                    case 'ATTACHMENT':
                        target.filter = Object.assign(target.filter, {
                            flags: { attached: true },
                        });
                        break;
                    default:
                        break;
                }
            }
        }
        return Object.assign(Object.assign({}, MailAbstractHandler.defaultRequestListMailEntry), target);
    }
    async buildThreadListEntryReq(param) {
        var _a, _b, _c;
        const initTarget = await this.buildListEntryReq(param);
        const target = {
            fids: Array.isArray(initTarget.fids) ? initTarget.fids : (initTarget.fid ? [initTarget.fid] : []),
            topFlag: initTarget.topFlag,
            returnTag: initTarget.returnTag,
            start: initTarget.start,
            limit: Math.min(512, initTarget.limit),
            summaryWindowSize: initTarget.summaryWindowSize,
            skipLockedFolders: initTarget.skipLockedFolders,
            returnAttachments: initTarget.returnAttachments,
            tag: initTarget.tag,
            mode: initTarget.mode || 'count',
            returnTotal: initTarget.returnTotal,
            returnTid: true,
            filterFlags: {
                read: (_b = (_a = initTarget.filter) === null || _a === void 0 ? void 0 : _a.flags) === null || _b === void 0 ? void 0 : _b.read,
                label0: (_c = initTarget.filter) === null || _c === void 0 ? void 0 : _c.label0,
            },
        };
        return Object.assign(Object.assign({}, MailAbstractHandler.defaultRequestListMailEntry), target);
    }
    getFids(needlockedFid = true, _account) {
        var _a, _b, _c;
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (needlockedFid) {
            return (_b = targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailBoxOriginData) === null || _b === void 0 ? void 0 : _b.map((it) => it.id);
        }
        return (_c = targetActions === null || targetActions === void 0 ? void 0 : targetActions.mailBoxOriginData) === null || _c === void 0 ? void 0 : _c.filter((it) => !(it === null || it === void 0 ? void 0 : it.auth2Locked)).map((it) => it.id);
    }
    buildEmptyMailEntryModel(param, noStore) {
        const { id, asAttachIds, _account, owner } = param;
        const uniqueId = id;
        const mailContentModel = {
            id: uniqueId || '',
            isOneRcpt: param.isOneRcpt,
            entry: {
                folder: 0,
                top: false,
                system: false,
                popRead: false,
                rcptSucceed: false,
                rcptFailed: false,
                withoutPlaceholder: param.withoutPlaceholder,
                title: param.title || '',
                sendTime: '',
                receiveTime: '',
                mark: 'none',
                attachmentCount: 0,
                attachment: [],
                readStatus: 'read',
                brief: '',
                id: uniqueId || '',
                asAttachIds,
                replayed: false,
                forwarded: false,
                isDraft: param.mailType && param.mailType === 'draft',
                isIcs: false,
                writeLetterProp: param && param.writeType,
                canRecall: false,
                threadMessageCount: 0,
                content: {
                    content: this.buildInitContent(param),
                    contentId: '',
                },
                memo: '',
            },
            extraOperate: param.extraOperate || '',
            receiver: [],
            sender: this.contactHandler.buildRawContactItem(undefined, _account),
            totalSize: 0,
            tags: [],
            headers: {},
            mailFormClickWriteMail: param.mailFormClickWriteMail,
            _account: param._account,
            owner,
        };
        if (param.colleagueAccId) {
            mailContentModel.tpMailInfo;
        }
        if (noStore) {
            return mailContentModel;
        }
        return this.modelHandler.updateLocalContent(mailContentModel);
    }
    testContentChange(origin, content) {
        if (origin.newUploadedAttachment && origin.newUploadedAttachment > 0) {
            return true;
        }
        return this.modelHandler.compare(origin, content) !== 0;
    }
    async doNeedSaveTemp(curCont) {
        const { cid } = curCont;
        if (!cid)
            return true;
        const content = cloneDeep(curCont);
        content.entry.content.content = this.modelHandler.getTransferHtml(content.entry.content, 'draftCompare');
        try {
            const localDrafts = await this.modelHandler.dbApi.getByEqCondition(Object.assign(Object.assign({}, mailUnfinishedMailTable), { query: { cid } }));
            if (!localDrafts || localDrafts.length === 0) {
                return true;
            }
            const orderedDrafts = util.setDataOrder({
                data: localDrafts,
                orderBy: [['createTime', false]],
            });
            const latestLocalDraft = orderedDrafts[0];
            const ret = this.testContentChange(latestLocalDraft, content);
            console.log('doNeedSaveTemp local compare result:', ret);
            return ret;
        }
        catch (error) {
            console.log('本地草稿对比失败', error);
            return true;
        }
    }
    handleAttachmentType(contentType, fileName) {
        return this.fileApi.judgeFileType(contentType, fileName);
    }
    static calculateTotalSize(attachments) {
        let ret = 0;
        if (attachments && attachments.length > 0) {
            ret = attachments.reduce((val, it) => {
                val += it.contentLength;
                return val;
            }, 0);
        }
        return ret;
    }
    handleAttachment(attachments, mid, params, bizParams) {
        const { forWrite, fromIMDisscuss, source, isTpMail, owner, tid, password, mailFrom, colleagueAccId, relatedEmailType, relatedEmailRefId, mainAccount } = params || {};
        const ret = [];
        if (attachments && attachments.length > 0) {
            attachments.forEach(item => {
                const { _account } = item;
                const fileType = this.handleAttachmentType(item.contentType, item.filename);
                const downloadUrl = this.buildAttachmentDownloadUrl(item, mid, {
                    isTpMail,
                    owner,
                    password,
                    mailFrom,
                    bizParams,
                    colleagueAccId,
                    relatedEmailType,
                    relatedEmailRefId,
                });
                const originUrl = this.buildAttachmentDownloadOriginUrl(item, mid, _account, {
                    isTpMail,
                    owner,
                    password,
                    mailFrom,
                    bizParams,
                    colleagueAccId,
                    relatedEmailType,
                    relatedEmailRefId,
                });
                const previewUrl = this.buildAttachmentPreviewUrl(item, mid, fileType, {
                    isTpMail,
                    owner,
                    tid,
                    password,
                    colleagueAccId,
                    mailFrom,
                    relatedEmailType,
                    relatedEmailRefId,
                    mainAccount,
                });
                const imDisscuss = fromIMDisscuss ? this.buildAttachmentUrlFromIMDisscuss(item, mid, _account) : undefined;
                const items = Object.assign(Object.assign({ realId: forWrite ? this.generateRndId() : 0, fileMime: item.contentType, fileName: item.filename, fileType, fileSize: item.estimateSize || item.contentLength, type: 'url', contentId: item.contentId, id: item.id, inlined: !!item.inlined, contentLocation: item.contentLocation, fileUrl: fromIMDisscuss ? imDisscuss : downloadUrl, fileOriginUrl: fromIMDisscuss ? imDisscuss : originUrl, deleted: false, ready: true, filePreviewUrl: fromIMDisscuss ? imDisscuss : previewUrl, fileSourceType: FileSourceType.downloadMail, fileSourceKey: mid + ';' + item.id }, (source === 'eml' && (item === null || item === void 0 ? void 0 : item.content) ? { fileContent: item.content } : {})), { _account });
                this.fileApi.registerTmpFile(items);
                ret.push(items);
            });
        }
        return ret;
    }
    async handleDecryptedMailResponse(retVal, attachments, password) {
        attachments === null || attachments === void 0 ? void 0 : attachments.forEach((it) => {
            it._account = retVal._account;
        });
        const attachmentsResult = this.handleAttachment(attachments, retVal.id, {
            forWrite: false,
            password,
        }) || [];
        retVal.entry.attachment = attachmentsResult;
        retVal.entry.isIcs = attachmentsResult === null || attachmentsResult === void 0 ? void 0 : attachmentsResult.some(it => it.fileType === 'ics');
        retVal.isDecrypted = true;
        await this.modelHandler.handleMailContentReplace(retVal, 'readMailFromNet');
        return retVal;
    }
    async handleMailContentResponse(res, readOnly, source, encoding, _account, mailFromValue, bizParams) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        const item = res[0];
        const mailFrom = (mailFromValue || res[0].mailFrom);
        let content;
        let conItem;
        let isHtml = false;
        if (item.html && item.html.content && item.html.content.length > 0) {
            conItem = item.html;
            isHtml = true;
        }
        else if (item.text && item.text.content && item.text.content.length > 0) {
            item.text.content = `<pre>${item.text.content.replace(/</g, '&lt;')}</pre>`;
            conItem = item.text;
        }
        else if (item.rtf && item.rtf.content && item.rtf.content.length > 0) {
            conItem = item.rtf;
        }
        if (conItem) {
            content = {
                contentId: conItem.contentId || '',
                isHtml,
                content: conItem.content,
                contentLen: conItem.contentLength,
                encoding: encoding || 'default',
            };
        }
        const currentUser = this.systemApi.getCurrentUser(_account);
        const retVal = {
            id: item.id,
            nonfold: item.nonfold,
            _account: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
            authAccountType: (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _a === void 0 ? void 0 : _a.authAccountType,
            entry: {
                folder: item.fid || 0,
                top: (_b = item.flags) === null || _b === void 0 ? void 0 : _b.top,
                system: ((_c = item.flags) === null || _c === void 0 ? void 0 : _c.system) || false,
                popRead: ((_d = item.flags) === null || _d === void 0 ? void 0 : _d.popRead) || false,
                rcptSucceed: ((_e = item.flags) === null || _e === void 0 ? void 0 : _e.rcptSucceed) || false,
                rcptFailed: ((_f = item.flags) === null || _f === void 0 ? void 0 : _f.rcptFailed) || false,
                title: this.htmlApi.encodeHtml(item.subject),
                sendTime: item.sentDate,
                receiveTime: item.receivedDate,
                mark: item.label0 === 1 ? 'redFlag' : 'none',
                attachmentCount: item.attachments ? item.attachments.length : 0,
                attachment: [],
                readStatus: !((_g = item.flags) === null || _g === void 0 ? void 0 : _g.read) ? 'unread' : 'read',
                brief: item.summary ? this.htmlApi.encodeHtml(item.summary) : undefined,
                id: item.id,
                replayed: (_h = item.flags) === null || _h === void 0 ? void 0 : _h.replied,
                forwarded: (_j = item.flags) === null || _j === void 0 ? void 0 : _j.forwarded,
                isDraft: (_k = item.flags) === null || _k === void 0 ? void 0 : _k.draft,
                isIcs: false,
                content: content || {
                    content: '',
                    contentId: '',
                    encoding: 'default',
                },
                memo: item.memo,
                threadMessageCount: item.threadMessageCount || 0,
                rclStatus: item.rclStatus,
                sndStatus: item.sndStatus,
                isScheduleSend: ((_l = item.flags) === null || _l === void 0 ? void 0 : _l.scheduleDelivery) || false,
                sentMailId: item.sentMailId,
                requestReadReceipt: item.requestReadReceipt,
                suspiciousSpam: !!((_m = item.flags) === null || _m === void 0 ? void 0 : _m.suspiciousSpam),
                tr_org_ec_id: (item === null || item === void 0 ? void 0 : item.headers) && (item === null || item === void 0 ? void 0 : item.headers['X-HM-EC-ID']),
            },
            receiver: item.receiver,
            isOneRcpt: (_o = item.composeExtra) === null || _o === void 0 ? void 0 : _o.showOneRcpt,
            sender: lodashGet(item, 'sender.0', {}),
            totalSize: MailContentHandler.calculateTotalSize(item.attachments),
            tags: item === null || item === void 0 ? void 0 : item.tag,
            headers: item.headers,
            scheduleDateTimeZone: item.clientTimeZone ? Number(item.clientTimeZone) : undefined,
            antispamInfo: item.antispamInfo,
            isTpMail: item.isTpMail,
            owner: item.owner,
            tpMailInfo: {
                belongEmail: item.subEmail,
                colleagueAccId: item.colleagueAccId,
                type: item.relatedEmailType,
                refId: item.relatedEmailRefId,
            },
        };
        (_p = item.attachments) === null || _p === void 0 ? void 0 : _p.forEach((it) => {
            it._account = _account;
        });
        const attachment = this.handleAttachment(item.attachments, item.id, {
            forWrite: false,
            fromIMDisscuss: readOnly,
            source,
            isTpMail: item.isTpMail,
            owner: item.owner,
            tid: item.tid,
            mailFrom,
            colleagueAccId: item.colleagueAccId,
            relatedEmailType: item.relatedEmailType,
            relatedEmailRefId: item.relatedEmailRefId,
        }, bizParams) || [];
        retVal.entry.attachment = attachment;
        retVal.entry.isIcs = attachment === null || attachment === void 0 ? void 0 : attachment.some(it => it.fileType === 'ics');
        retVal.isEncryptedMail = attachment ? getIsEncryptedMail(attachment) : false;
        if (readOnly) {
            await this.modelHandler.handleMailContentReplace(retVal, 'readMailReadOnly', undefined, item.isTpMail);
        }
        else {
            await this.modelHandler.handleMailContentReplace(retVal, 'readMailFromNet', undefined, item.isTpMail);
        }
        return retVal;
    }
    buildAttachmentDownloadOriginUrl(item, mid, _account, config) {
        const { isTpMail, owner, mailFrom, colleagueAccId, bizParams, password, relatedEmailType, relatedEmailRefId } = config || {};
        const req = {
            mid,
            Part: item.id + '',
            email: owner || '',
        };
        if (password) {
            return this.buildUrl('getDecryptedMailPart', Object.assign(Object.assign({}, req), { password }), true, item._account);
        }
        if (mailFrom === 'customer' || mailFrom === 'relatedEmail') {
            if (mailFrom === 'relatedEmail') {
                const type = relatedEmailType === 'CUSTOMER' ? 'conversation' : 'hint';
                req.type = type;
                req.refId = relatedEmailRefId;
            }
            return this.impl.buildUrl(this.systemApi.getUrl('getTpMailPart', undefined, undefined, _account), req);
        }
        if (!isTpMail) {
            return this.buildUrl('getMailPart', req, true, item._account);
        }
        if (mailFrom === 'biz' && bizParams) {
            req.bizId = bizParams.bizId;
            req.accId = bizParams.accId;
            req.mailboxAccId = bizParams.mailboxAccId;
            return this.impl.buildUrl(this.systemApi.getUrl('getBizMailData', undefined, undefined, _account), req);
        }
        if (colleagueAccId) {
            req.colleagueAccId = colleagueAccId;
            req.subEmail = owner || '';
            return this.impl.buildUrl(this.systemApi.getUrl('getTpMailPartNew', undefined, undefined, _account), req);
        }
        return this.impl.buildUrl(this.systemApi.getUrl('getTpMailPart', undefined, undefined, _account), req);
    }
    buildAttachmentUrlFromIMDisscuss(item, mid, _account) {
        const req = {
            part: item.id,
            emailMid: mid,
        };
        const url = this.systemApi.getUrl('discussMailAttach', undefined, undefined, _account);
        return this.impl.buildUrl(url, req);
    }
    buildAttachmentDownloadUrl(item, mid, config) {
        var _a;
        const { isTpMail, owner, mailFrom, colleagueAccId, bizParams, noSid, password, preview, relatedEmailType, relatedEmailRefId } = config || {};
        const isSubAccount = this.mailConfApi.isSubAccount(item._account);
        const _session = isSubAccount ? this.systemApi.getSessionNameOfSubAccount(item._account || '') : '';
        const _appName = this.systemApi.getAppName();
        const req = {
            mode: preview ? 'inline' : 'download',
            part: String(item.id),
            mid,
            _session,
            email: owner || '',
            _appName,
        };
        if (isSubAccount && !process.env.BUILD_ISELECTRON) {
            delete req._session;
            const token = ((_a = this.mailConfApi.accountTokens.find(token => token.account === item._account)) === null || _a === void 0 ? void 0 : _a.token) || '';
            const user = this.systemApi.getCurrentUser(item._account);
            if (token && user) {
                req._token = token;
                req.sid = user.sessionId || '';
                req.func = 'mbox:getMessageData';
            }
        }
        if (mailFrom === 'biz' && bizParams && isTpMail) {
            req.bizId = bizParams.bizId;
            req.accId = bizParams.accId;
            req.mailboxAccId = bizParams.mailboxAccId;
        }
        if (mailFrom === 'relatedEmail') {
            const type = relatedEmailType === 'CUSTOMER' ? 'conversation' : 'hint';
            req.type = type;
            req.refId = relatedEmailRefId;
            req.subEmail = owner || '';
        }
        let downloadUrl = '';
        if (password) {
            downloadUrl = this.buildUrl('getDecryptedMailPart', Object.assign(Object.assign({}, req), { password }), noSid, item._account);
        }
        else if (isTpMail || mailFrom === 'customer') {
            if (mailFrom === 'biz') {
                downloadUrl = this.impl.buildUrl(this.systemApi.getUrl('getBizMailData'), req);
            }
            else if (colleagueAccId) {
                req.colleagueAccId = colleagueAccId;
                req.subEmail = owner || '';
                downloadUrl = this.impl.buildUrl(this.systemApi.getUrl('getTpMailPartNew'), req);
            }
            else {
                downloadUrl = this.impl.buildUrl(this.systemApi.getUrl('getTpMailPart'), req);
            }
        }
        else if (isSubAccount && !process.env.BUILD_ISELECTRON && !this.systemApi.isElectron()) {
            downloadUrl = this.buildUrl('getMailPart', req, noSid, item._account, 'mailProxyOperation');
        }
        else {
            downloadUrl = this.buildUrl('getMailPart', req, noSid, item._account);
        }
        if (downloadUrl && !downloadUrl.startsWith('http')) {
            downloadUrl = locationHelper.getProtocol() + locationHelper.getHost() + downloadUrl;
        }
        return downloadUrl;
    }
    buildAttachmentPreviewUrl(item, mid, fileType, config) {
        const { isTpMail, owner, mailFrom, colleagueAccId, tid, password, relatedEmailType, relatedEmailRefId, mainAccount } = config || {};
        if (fileType === 'png' || fileType === 'jpeg' || fileType === 'jpg' || fileType === 'gif') {
            return this.buildAttachmentDownloadUrl(item, mid, { isTpMail, owner, password, mailFrom, colleagueAccId, preview: true, relatedEmailType, relatedEmailRefId });
        }
        const user = this.systemApi.getCurrentUser(item === null || item === void 0 ? void 0 : item._account);
        if (!user) {
            return '';
        }
        const subAccount = this.accountApi.getEmailIdByEmail((item === null || item === void 0 ? void 0 : item._account) || '');
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const host = isCorpMail
            ?
                user.domain
            : this.mailConfApi.getWebMailHost(true, subAccount).replace(/^.*?:\/\//, '');
        let url = '';
        let req = {};
        const isSubAccount = !!subAccount;
        if (isTpMail || mailFrom === 'customer' || mailFrom === 'relatedEmail') {
            url = this.systemApi.getUrl(colleagueAccId ? 'getTpMailPreviewNew' : 'getTpMailPreview');
            let type = '';
            if (mailFrom === 'relatedEmail') {
                type = relatedEmailType === 'CUSTOMER' ? 'conversation' : 'hint';
            }
            req = {
                uid: owner,
                host,
                tid,
                mid,
                part: item.id + '',
                product: 'MAIL',
                fullFileName: item.filename,
                colleagueAccId,
                subEmail: owner,
                type,
                refId: relatedEmailRefId,
            };
        }
        else {
            url = this.systemApi.getUrl('filePreview');
            req = {
                product: 'MAIL',
                fullFileName: item.filename,
                sid: user.sessionId,
                url: this.buildAttachmentDownloadUrl(item, mid, { password, noSid: true }),
                uid: user.id,
                mid,
                part: item.id + '',
                host,
                _session: '',
            };
            if (mainAccount) {
                req.mainAccount = mainAccount;
            }
        }
        if (process.env.BUILD_ISELECTRON && isSubAccount) {
            const sessionName = this.systemApi.getSessionNameOfSubAccount(item._account || '');
            if (sessionName) {
                req._session = sessionName;
            }
        }
        return this.impl.buildUrl(url, req);
    }
    async doCheckReadStatus(mid, _account, fetchDeliveryHistory = false) {
        const key = 'checkPostMail';
        const url = this.buildUrl(key, undefined, undefined, _account);
        const data1 = { mid, _subaccount: _account };
        if (fetchDeliveryHistory) {
            data1.pid = mid;
        }
        const apiResponsePromise = this.impl.post(url, data1, this.getConfigForHttp(key, { url, data: data1, _account }));
        return apiResponsePromise.then(this.unpackData.bind(this)).then(async (res) => {
            var _a, _b;
            if (res && res.code === MailAbstractHandler.sOk && res.var && res.var.length > 0) {
                const { var: data = [] } = res;
                const tid = (_a = data[0]) === null || _a === void 0 ? void 0 : _a.tid;
                const sentDate = (_b = data[0]) === null || _b === void 0 ? void 0 : _b.modtime;
                const mailTraceUrl = this.systemApi.getAccountUrl('mailTraceStatus', _account);
                let newData = [];
                const isCorpMail = this.systemApi.getIsCorpMailMode();
                if (!isCorpMail) {
                    try {
                        const response = await this.impl.post(mailTraceUrl, { tid, sentDate }, { contentType: 'form', _account });
                        const { result } = this.unpackData(response);
                        newData = result === null || result === void 0 ? void 0 : result.data;
                    }
                    catch (error) {
                        newData = [];
                    }
                }
                const ownDomainSet = await this.accountApi.doGetOwnDomainSet(_account);
                const _data = mergeMailStatusList(data, newData, ownDomainSet);
                const contactList = _data.map(it => it.to);
                return this.contactHandler.getContractItemByEmail(contactList, '', _account).then((ret) => {
                    const contactMap = {};
                    if (ret && ret.length > 0) {
                        ret.forEach(it => {
                            contactMap[it.contactItem.contactItemVal] = it.contact;
                        });
                    }
                    return {
                        status: res.code,
                        tid,
                        detail: _data.map(it => {
                            const contactMapElement = contactMap[it.to];
                            return {
                                result: it.result,
                                email: it.to,
                                rclResult: it.rclResult,
                                contact: contactMapElement,
                                contactName: contactMapElement === null || contactMapElement === void 0 ? void 0 : contactMapElement.contact.contactName,
                                avatar: (contactMapElement === null || contactMapElement === void 0 ? void 0 : contactMapElement.contact.avatar) || (contactMapElement === null || contactMapElement === void 0 ? void 0 : contactMapElement.contact.contactLabel),
                                originModtime: it.originModtime,
                                modifiedTime: it.modtime,
                                msgType: it.msgType,
                                mid,
                                tid,
                                inner: it === null || it === void 0 ? void 0 : it.inner,
                                msgid: it === null || it === void 0 ? void 0 : it.msgid,
                            };
                        }),
                        externalDetail: newData,
                    };
                });
            }
            return {
                status: 'FA_MAIL_EXPIRED',
                tid: '',
                detail: [],
            };
        });
    }
    async doGetMailReadCount(params) {
        const url = this.systemApi.getUrl('getMailReadCount');
        const response = await this.impl.post(url, params, { contentType: 'json', _account: params._account });
        return response.data;
    }
    async doGetMailReadDetail(params) {
        const url = this.systemApi.getUrl('getMailReadDetail');
        const response = await this.impl.post(url, params, { contentType: 'json', _account: params._account });
        return response.data;
    }
    async checkReadStatusOfSentMailMoreAccount(result, param) {
        let res = {};
        try {
            const data = Array.isArray(result) ? result : result.data;
            let { _account } = param;
            const accountList = [];
            let start = null;
            let end = null;
            if (Array.isArray(data) && data.length) {
                data.forEach(mail => {
                    var _a, _b, _c, _d, _e;
                    const isSendBox = mail.entry.folder === mailBoxOfSent.id;
                    _account = mail._account || _account;
                    const senderEmail = this.contactApi.doGetModelDisplayEmail((_a = mail.sender) === null || _a === void 0 ? void 0 : _a.contact);
                    const isSendMail = this.accountApi.getIsSameSubAccountSync(senderEmail, _account);
                    const accountAlias = (_c = (_b = this.systemApi.getCurrentUser(_account)) === null || _b === void 0 ? void 0 : _b.prop) === null || _c === void 0 ? void 0 : _c.accountAlias;
                    const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
                    const isAliasSend = accountAliasArray.some(acc => this.accountApi.getIsSameSubAccountSync(senderEmail, acc));
                    const isSend = isSendBox || isSendMail || isAliasSend;
                    const authAccountType = (_e = (_d = this.systemApi.getCurrentUser(_account)) === null || _d === void 0 ? void 0 : _d.prop) === null || _e === void 0 ? void 0 : _e.authAccountType;
                    const type = authAccountType && authAccountType !== '0' ? 1 : 0;
                    if (isSend) {
                        const accountItem = accountList.find(acc => acc.email === _account);
                        if (accountItem) {
                            accountItem.detail.push({
                                tid: mail.entry.tid,
                                mid: mail.entry.id,
                            });
                        }
                        else {
                            accountList.push({
                                email: _account,
                                type,
                                detail: [
                                    {
                                        tid: mail.entry.tid,
                                        mid: mail.entry.id,
                                    },
                                ],
                            });
                        }
                        if (type === 0) {
                            if (!start) {
                                start = mail.entry.sendTime;
                            }
                            if (!end) {
                                end = mail.entry.sendTime;
                            }
                            if (moment(mail.entry.sendTime).isBefore(moment(start))) {
                                start = mail.entry.sendTime;
                            }
                            if (moment(mail.entry.sendTime).isAfter(moment(end))) {
                                end = mail.entry.sendTime;
                            }
                        }
                    }
                });
                if (accountList && accountList.length) {
                    const url = this.systemApi.getUrl('getSendStatusMoreAccounts');
                    const response = await this.impl.post(url, { accountList, start, end }, { contentType: 'json', _account });
                    const { data, success } = (response === null || response === void 0 ? void 0 : response.data) || {};
                    if (success && data.accountList && data.accountList.length) {
                        const resMap = {};
                        data.accountList.forEach(item => {
                            if (item.detail && item.detail.length) {
                                item.detail.forEach(m => {
                                    const { tid, rcptCount, innerCount, readCount, innerRead, readNum, innerReadNum, thirdCount } = m;
                                    resMap[tid] = {
                                        rcptCount,
                                        readCount,
                                        innerCount,
                                        innerRead,
                                        openCount: thirdCount,
                                    };
                                });
                            }
                        });
                        res = resMap;
                    }
                }
            }
        }
        catch (error) {
            console.error('checkReadStatusOfSentMailMoreAccount error', error);
        }
        return res;
    }
    async checkReadStatusOfSentMail(result, param) {
        var _a, _b;
        let res = {};
        try {
            if (param.subEmails && param.subEmails.length > 1) {
                return this.checkReadStatusOfSentMailMoreAccount(result, param);
            }
            const data = Array.isArray(result) ? result : result.data;
            const { _account } = param;
            if (Array.isArray(data) && data.length) {
                const sendDatas = data.filter(mail => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    const isSendBox = mail.entry.folder === mailBoxOfSent.id;
                    const senderEmail = ((_c = (_b = (_a = mail.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.displayEmail) || ((_f = (_e = (_d = mail.sender) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.accountName);
                    const isSendMail = this.accountApi.getIsSameSubAccountSync(senderEmail, _account);
                    const accountAlias = (_h = (_g = this.systemApi.getCurrentUser(_account)) === null || _g === void 0 ? void 0 : _g.prop) === null || _h === void 0 ? void 0 : _h.accountAlias;
                    const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
                    const isAliasSend = accountAliasArray.some(acc => this.accountApi.getIsSameSubAccountSync(senderEmail, acc));
                    return isSendBox || isSendMail || isAliasSend;
                });
                if (sendDatas.length) {
                    const authAccountType = (_b = (_a = this.systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.authAccountType;
                    if (authAccountType && authAccountType !== '0') {
                        const mailList = sendDatas.map(i => {
                            var _a, _b, _c, _d;
                            return ({
                                tid: i.entry.tid,
                                mid: i.entry.id,
                                fromEmail: ((_b = (_a = i.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact.displayEmail) || ((_d = (_c = i.sender) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.contact.accountName),
                            });
                        });
                        const url = this.systemApi.getUrl('getMailReadCountBatch');
                        const response = await this.impl.post(url, { mailList }, { contentType: 'json', _account });
                        const { data, success } = (response === null || response === void 0 ? void 0 : response.data) || {};
                        if (success && data.mailList && data.mailList.length) {
                            const countMap = {};
                            data.mailList.forEach((m) => {
                                const { tid, count } = m;
                                if (tid) {
                                    countMap[tid] = {
                                        openCount: +count || 0,
                                    };
                                }
                            });
                            res = countMap;
                        }
                    }
                    else {
                        let start = sendDatas[0].entry.sendTime;
                        let end = sendDatas[0].entry.sendTime;
                        const tids = sendDatas.map(i => {
                            if (moment(i.entry.sendTime).isBefore(moment(start))) {
                                start = i.entry.sendTime;
                            }
                            if (moment(i.entry.sendTime).isAfter(moment(end))) {
                                end = i.entry.sendTime;
                            }
                            return i.entry.tid;
                        });
                        const mailsReadStatusUrl = this.systemApi.getUrl('mailsReadStatus', undefined, undefined, _account);
                        const params = {
                            tids: tids.join(','),
                            start,
                            end,
                        };
                        const response = await this.impl.post(mailsReadStatusUrl, params, { contentType: 'form', _account });
                        const { result } = this.unpackData(response);
                        res = (result === null || result === void 0 ? void 0 : result.data) || {};
                    }
                }
            }
        }
        catch (error) {
            console.error('checkReadStatusOfSentMail error', error);
        }
        return res;
    }
    async listAttachments(params) {
        var _a;
        const url = this.buildUrl('listAttachments');
        const res = await this.impl.post(url, params, { contentType: 'json', cachePolicy: 'noCache' });
        const unpackRes = this.unpackData(res);
        if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === MailAbstractHandler.sOk) {
            const { total, var: list, notReady } = unpackRes;
            return {
                total,
                list,
                notReady,
                success: true,
            };
        }
        return {
            success: false,
            error: res.code ? ErrResult[res.code] : ErrResult.FS_UNKNOWN,
        };
    }
    async uploadMail(fid, file, _account) {
        const url = this.buildUrl('uploadMail', { fid: fid + '', date: Date.now() + '' }, undefined, _account);
        return this.impl
            .post(url, file, {
            headers: {
                'Content-Type': 'application/octet-stream',
            },
            contentType: 'arraybuffer',
            _account: _account || '',
            timeout: 3 * 60 * 1000,
            noEnqueue: true,
        })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res && res.code === MailAbstractHandler.sOk && res.var) {
                return {
                    mid: res.var.mailUniqueId,
                };
            }
            try {
                this.loggerApi.track('import_mail_web_error', {
                    result: res,
                    error: 'web_import_mail_error',
                });
            }
            catch (error) {
                console.error('import_mail_web_error error', error);
            }
            return Promise.reject((res === null || res === void 0 ? void 0 : res.code) && ErrResult[res.code] ? ErrResult[res.code].title : '邮件导入失败');
        });
    }
    getMailDeliveryDetail(mid, _account) {
        const url = this.systemApi.getUrl('getDeliveryDetail');
        const req = {
            emailMid: mid,
        };
        return this.impl
            .post(url, req, {
            url,
            contentType: 'json',
            cachePolicy: 'noCache',
            noEnqueue: true,
            _account,
        })
            .then(res => {
            const { data, code } = res.data;
            if (+code === 0 && data) {
                return data;
            }
            return Promise.reject(this.getErrMsg(code));
        })
            .catch(err => Promise.reject(err));
    }
    async doRequestSequential(params) {
        var _a;
        const _params = params
            .filter(v => methodMap[v.func])
            .map(v => ({
            func: methodMap[v.func],
            var: Array.isArray(v.var) && v.var.length === 0 ? undefined : v.var,
        }));
        const reqParams = {
            var: getXmlByObject(_params),
        };
        const key = 'sequential';
        const url = this.buildUrl(key);
        const result = await this.impl.post(url, reqParams, { data: reqParams, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
        console.log(result);
        return (_a = result.data) === null || _a === void 0 ? void 0 : _a.var;
    }
    async doGetMailContentInquiry(handoverEmailId) {
        if (!handoverEmailId) {
            return Promise.reject(new Error('no handoverEmailId input'));
        }
        const httpApi = api.getDataTransApi();
        const url = this.systemApi.getUrl('getMailContentInquiry');
        const mailEntryModelPromise = await httpApi
            .get(url, { handoverEmailId })
            .then(res => {
            if (res && res.data && res.data.success) {
                return res.data.data;
            }
            return Promise.reject(new Error('获取邮件详情失败'));
        })
            .then(res => {
            const { mid, emailInfo } = res;
            const data = JSON.parse(emailInfo);
            const prItem = this.contactHandler.mapMailEntryToProcessingItem(data, mid);
            const promise = this.contactHandler.handleContactList([prItem]);
            return promise;
        })
            .then((res) => this.handleMailContentResponse(res, true))
            .then(res => setMailAttSource(res, 'content'));
        return mailEntryModelPromise;
    }
}
MailContentHandler.debugMailPopWindow = false;
MailContentHandler.decryptedErrorCode = {
    FA_MAIL_NOT_FOUND: getIn18Text('FA_MAIL_NOT_FOUND'),
    FA_PART_NOT_FOUND: getIn18Text('FA_PART_NOT_FOUND'),
    FA_INVALID_PART: getIn18Text('FA_EMPTY_PASSWORD'),
    FA_EMPTY_PASSWORD: getIn18Text('FA_EMPTY_PASSWORD'),
    FA_INVALID_PASSWORD: getIn18Text('FA_INVALID_PASSWORD'),
    FA_INVALID_ENCRYPTED_DATA: getIn18Text('FA_INVALID_ENCRYPTED_DATA'),
};
